import { ClosePopup as e, QBadge as t, QBtn as n, QCarousel as r, QCarouselSlide as i, QCheckbox as a, QDialog as o, QField as s, QForm as c, QIcon as l, QImg as u, QInput as d, QItem as f, QItemLabel as p, QItemSection as m, QList as h, QMenu as ee, QRadio as te, QSelect as ne, QSeparator as g, QSpace as re, QSpinner as _, QStep as v, QStepper as ie, QStepperNavigation as ae, QTooltip as y, date as oe, useDialogPluginComponent as b, useQuasar as se } from "quasar";
import { Fragment as x, computed as S, createBlock as C, createCommentVNode as w, createElementBlock as T, createElementVNode as E, createSlots as ce, createStaticVNode as le, createTextVNode as D, createVNode as O, defineComponent as k, guardReactiveProps as ue, inject as de, mergeModels as A, nextTick as fe, normalizeClass as j, normalizeProps as pe, normalizeStyle as M, onBeforeMount as N, onBeforeUnmount as me, onMounted as he, openBlock as P, provide as ge, ref as F, renderList as _e, renderSlot as I, toDisplayString as L, unref as R, useModel as z, watch as B, withCtx as V, withDirectives as ve, withModifiers as ye } from "vue";
import { BrandDropdownSelector as be, CMSDialog as xe, CMSNotification as H, VuetifyValidationRules as Se, formatDateDots as Ce, getI18n as we, registerEntityEndpoint as Te, useDialogStore as Ee, useNotificationStore as De } from "@editor/ui-utils";
import { useI18n as U } from "vue-i18n";
import { defineStore as Oe } from "pinia";
import { SocialLinkUtils as ke, deEscapeCharacters as Ae, stripHtmlTags as je } from "@utils/string-utils";
import { ImageEdit as Me, ImageService as Ne, getImage as Pe, getImageUrl as Fe, prefillEditorImage as Ie } from "@modules/image-editor-ui-components";
import { getCtaButton as Le, getEmptyCtaButton as Re } from "@modules/cta-button-editor-ui";
import { getEmptyNewsletter as ze, getNewsletter as Be } from "@modules/newsletter-editor-ui";
import { getEmptyReusableText as Ve, getReusableText as He } from "@modules/reusable-text-editor-ui";
import { useListLocking as Ue } from "@modules/locking-editor-ui-components";
//#endregion
//#region src/lang/index.ts
var We = {
	en: {
		assemblerAissistTransform: {
			transform: "AISSIST transformation",
			prompt: "Default prompt",
			additionalInstructions: "Additional adjustments (tone, length, emphasis)",
			additionalInstructionsPlaceholder: "e.g. use a more informal tone, shorten the text, or emphasize a specific angle",
			promptPlaceholder: "Choose an already existing prompt or type in your custom prompt here",
			atLeastOnePromptRequired: "Either the default prompt or additional instructions must contain text",
			promptSelectPlaceholder: "Select a prompt",
			searchPrompts: "Search prompts",
			matchingPrompts: "Matching prompts",
			otherPrompts: "Other prompts",
			promptStart: "Beginning of prompt (predefined)",
			processFormat: "Process article in format",
			html: "HTML",
			markdown: "Markdown",
			checkResult: "Check result",
			original: "Original",
			aissistOutput: "AISSIST output",
			startAgain: "Start again",
			refinementInstructions: "Refine AISSIST transform result",
			refinementInstructionsPlaceholder: "e.g. shorten the lead, make subheadings more direct, or remove the second paragraph",
			refine: "Refine",
			refineLoadingMessage: "Refining AISSIST transform result. Hang on, this might take up to 90 seconds...",
			loadingMessage: "Sending article to AISSIST. Hang on, this might take a while.",
			refetchPrompts: "Refetch prompts",
			refetchProviders: "Refetch providers",
			additionalSettings: "Additional settings",
			provider: { label: "Provider" },
			brand: "Brand",
			actionType: {
				label: "Action type",
				rephrase: "Rephrase",
				translate: "Translate",
				seo: "SEO",
				optimize: "Optimize"
			},
			promptInputTooltip: {
				expand: "Expand full prompt",
				minimize: "Collapse prompt"
			},
			error: {
				promptNotFound: "Failed to find requested prompt",
				fetchPromptsError: "Error getting prompts from AISSIST",
				fetchPromptsNoDataInfo: "No prompts received. Actions cannot be used, but you can still enter your own prompt.",
				fetchProvidersNoDataInfo: "No providers were received from AISSIST",
				transformDisabled: "Aissist transformation is not allowed for this article",
				transformTimeout: "AISSIST transformation timed out (90s limit)",
				transformErrorGeneral: "AISSIST transformation failed",
				transformInitError: "Failed to start the AISSIST transformation"
			}
		},
		assemblerPreview: {
			missingCredits: "Image credit missing",
			missingCaption: "Image caption missing",
			ctaButtonLoading: "Loading CTA button",
			ctaButtonLoadingFailed: "Loading CTA button failed",
			newsletterLoading: "Loading newsletter",
			newsletterLoadingFailed: "Loading newsletter failed",
			reusableTextLoading: "Loading reusable text",
			reusableTextLoadingFailed: "Loading reusable text failed",
			imageImportTooltip: "Import image",
			imageEditTooltip: "Edit image",
			imageImportError: "Error fetching image",
			imageImportMissingAssetId: "This image cannot be imported yet because Content Assembler has not assigned a stable asset id. Please try again after CA migration has finished.",
			missingImageSource: "No image source provided",
			unsupportedFormat: "Unsupported image format",
			imageFetchFailed: "Failed to load image (HTTP {status})",
			imageLoadError: "Error loading image",
			partnerProfilePages: "Partner profile pages",
			messageHideArticleFromListing: "The article will no longer be visible to anyone in Vibe.",
			messageHideArticleFromListingTitle: "Are you sure that you want to hide this article from everyone?",
			articleHiddenFromListing: "Article hidden",
			errorOnArticleHiding: "Failed to hide article from Vibe",
			hide: "Hide",
			messageShowArticleInListing: "The article will be visible again to everyone in Vibe.",
			messageShowArticleInListingTitle: "Are you sure that you want to make this article visible again?",
			articleShownInListing: "Article visible again",
			show: "Show",
			hiddenInListing: "Hidden in listing",
			ednotes: {
				title: "Editorial notes",
				correction: "Correction",
				editorialnote: "Editorial note",
				edservice: "Editorial service",
				embargo: "Embargo",
				picture: "Picture",
				other: "Notes"
			}
		}
	},
	de: {
		assemblerAissistTransform: {
			transform: "AISSIST-Transformation",
			prompt: "Standard-Prompt",
			additionalInstructions: "Zusätzliche Anpassungen (Ton, Länge, Schwerpunkte)",
			additionalInstructionsPlaceholder: "z. B. lockerer formulieren, kürzer schreiben oder einen Aspekt stärker betonen",
			promptPlaceholder: "Wähle einen bereits vorhandenen Prompt aus oder gib deinen eigenen Prompt hier ein",
			atLeastOnePromptRequired: "Entweder der Standard-Prompt oder die zusätzlichen Anweisungen müssen Text enthalten",
			promptSelectPlaceholder: "Prompt auswählen",
			searchPrompts: "Prompts suchen",
			matchingPrompts: "Passende Prompts",
			otherPrompts: "Weitere Prompts",
			promptStart: "Beginn des Prompts (vordefiniert)",
			processFormat: "Artikel verarbeiten im Format",
			html: "HTML",
			markdown: "Markdown",
			checkResult: "Ergebnis prüfen",
			original: "Original",
			aissistOutput: "AISSIST-Ergebnis",
			startAgain: "Von vorne beginnen",
			refinementInstructions: "AISSIST-Transformationsergebnis verfeinern",
			refinementInstructionsPlaceholder: "z. B. Lead kürzen, Zwischenüberschriften direkter formulieren oder den zweiten Absatz streichen",
			refine: "Verfeinern",
			refineLoadingMessage: "AISSIST-Transformationsergebnis wird verfeinert. Bitte warten, dies kann bis zu 90 Sekunden dauern...",
			loadingMessage: "Artikel wird an AISSIST gesendet. Bitte warten, das kann eine Weile dauern .",
			refetchPrompts: "Prompts erneut abrufen",
			refetchProviders: "Provider erneut laden",
			additionalSettings: "Zusätzliche Einstellungen",
			provider: { label: "Provider" },
			brand: "Brand",
			actionType: {
				label: "Aktion",
				rephrase: "Umformulieren",
				translate: "Übersetzen",
				seo: "SEO",
				optimize: "Optimieren"
			},
			promptInputTooltip: {
				expand: "Kompletten Prompt ausklappen",
				minimize: "Prompt einklappen"
			},
			error: {
				promptNotFound: "Der Prompt wurde nicht gefunden.",
				fetchPromptsError: "Fehler beim Laden der Prompts von AISSIST",
				fetchPromptsNoDataInfo: "Keine Prompts empfangen. Derzeit sind keine Aktionen möglich, aber du kannst deinen eigenen Prompt eingeben.",
				fetchProvidersNoDataInfo: "Es wurden keine Provider von AISSIST empfangen",
				transformDisabled: "Aissist transformation ist für diesen Artikel nicht gestattet",
				transformTimeout: "Zeitüberschreitung bei der AISSIST-Transformation (90-Sekunden-Limit)",
				transformErrorGeneral: "Die AISSIST-Konvertierung ist fehlgeschlagen",
				transformInitError: "Die AISSIST-Transformation konnte nicht gestartet werden"
			}
		},
		assemblerPreview: {
			missingCredits: "Bild-Credit fehlt",
			missingCaption: "Bildunterschrift fehlt",
			ctaButtonLoading: "CTA-Button wird geladen",
			ctaButtonLoadingFailed: "Laden des CTA-Buttons fehlgeschlagen",
			newsletterLoading: "Newsletter wird geladen",
			newsletterLoadingFailed: "Laden des Newsletters fehlgeschlagen",
			reusableTextLoading: "Wiederverwendbarer Text wird geladen.",
			reusableTextLoadingFailed: "Laden des wiederverwendbaren Texts fehlgeschlagen",
			imageImportTooltip: "Bild importieren",
			imageEditTooltip: "Bild bearbeiten",
			imageImportError: "Fehler beim Laden des Bildes",
			imageImportMissingAssetId: "Dieses Bild kann noch nicht importiert werden, weil Content Assembler noch keine stabile Asset-ID zugewiesen hat. Bitte versuche es erneut, nachdem die CA-Migration abgeschlossen ist.",
			missingImageSource: "Keine Bildquelle angegeben",
			unsupportedFormat: "Nicht unterstütztes Bildformat",
			imageFetchFailed: "Bild konnte nicht geladen werden (HTTP {status})",
			imageLoadError: "Fehler beim Laden des Bildes",
			partnerProfilePages: "Partner-Profilseiten",
			messageHideArticleFromListing: "Der Artikel wird nicht länger in Vibe zu sehen sein.",
			messageHideArticleFromListingTitle: "Bist du sicher, dass du diesen Artikel vor allen verbergen möchtest?",
			articleHiddenFromListing: "Artikel ausgeblendet",
			errorOnArticleHiding: "Fehler beim Ausblenden des Artikels in Vibe",
			hide: "Verbergen",
			messageShowArticleInListing: "Der Artikel wird wieder für alle in Vibe sichtbar sein.",
			messageShowArticleInListingTitle: "Bist du sicher, dass du diesen Artikel wieder sichtbar machen möchtest?",
			articleShownInListing: "Artikel wieder sichtbar",
			show: "Anzeigen",
			hiddenInListing: "Im Listing ausgeblendet",
			ednotes: {
				title: "Notizblock",
				correction: "Berichtigung",
				editorialnote: "Redaktionshinweis",
				edservice: "Redaktionsservice",
				embargo: "Embargo",
				picture: "Bildhinweis",
				other: "Hinweise"
			}
		}
	}
}, W;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.FITFORFUN = "fitforfun", e.FINANZEN100 = "finanzen100", e.MITTIER = "mittier", e.MITSTERNEN = "mitsternen", e.MITBEZIEHUNG = "mitbeziehung", e.TVTODAY = "tvtoday", e.TVSPIELFILM = "tvspielfilm";
})(W ||= {}), Object.freeze(W);
var Ge;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.PRAXISTIPPS = "praxistipps";
})(Ge ||= {}), Object.freeze(Ge), Object.freeze([
	W.MITTIER,
	W.MITSTERNEN,
	W.MITBEZIEHUNG,
	W.TVTODAY,
	W.TVSPIELFILM
]), Object.freeze({
	[W.BUNTE]: "bunte",
	[W.CHIP]: "chip",
	[W.FOCUS]: "focus",
	[W.FITFORFUN]: "fitforfun",
	[W.FINANZEN100]: "finanzen100",
	[W.MITTIER]: "default-verticals",
	[W.MITSTERNEN]: "default-verticals",
	[W.MITBEZIEHUNG]: "default-verticals",
	[W.TVTODAY]: "default",
	[W.TVSPIELFILM]: "default"
});
var Ke = Object.freeze(Object.values(W));
Object.freeze(Object.values(Ge)), W.BUNTE, W.CHIP, W.FOCUS, W.FITFORFUN, W.TVSPIELFILM, W.TVTODAY, W.BUNTE, W.CHIP, W.FOCUS, W.FITFORFUN, W.TVSPIELFILM, W.TVTODAY;
//#endregion
//#region src/services/aissist.service.ts
var { getEntityAPIClient: qe } = Te("Aissist", "/cms/assembler/aissist"), Je = qe(), Ye = async (e) => (await Je.post("asyncTransformInit", e)).data, Xe = async (e) => (await Je.get(`asyncTransformResult/${e}`)).data, Ze = async (e) => (await Je.post("prompt-templates-by-tags", { tags: e })).data, Qe = async () => (await Je.get("providers")).data, $e = "Assembler", et = Te($e, "/cms/assembler/contents"), { getEntityAPIClient: tt } = et, nt = tt(), rt = async (e, t) => {
	await nt.put(`${e}/ctfMeta/importHistory`, t);
}, it = "AssemblerFeed", at = Te(it, "/cms/assembler/feeds"), { getEntity: ot } = at, st = async (e) => ot(e), ct = "AssemblerFeedStats", lt = Te(ct, "/cms/assembler/feed-stats"), { listEntities: ut, getEntityAPIClient: dt } = lt, ft = dt(), pt = async (e) => ut(e), mt = async (e, t, n = "json", r) => {
	let i = n === "json" ? "json" : "blob", { data: a } = await ft.get(`report/complete/${e}/${t}`, {
		params: { format: n },
		responseType: i,
		...r
	});
	return a;
}, ht = ["assembler"], gt = Oe("aissistPrompts", {
	state: () => ({
		arePromptsInitialized: !1,
		isInitializingPrompts: !1,
		aissistPrompts: []
	}),
	actions: { getPromptTemplate() {
		return { system_prompt: "" };
	} },
	persist: !1
}), _t = async () => {
	let e = gt(), { t } = we();
	if (e.isInitializingPrompts || e.arePromptsInitialized) return;
	e.isInitializingPrompts = !0;
	let n = De();
	try {
		e.aissistPrompts = [...await Ze(ht)], e.aissistPrompts.length || n.showNotification(new H(t("assemblerAissistTransform.error.fetchPromptsNoDataInfo"), "info", {
			timeout: null,
			dismissible: !0,
			callbackLabel: t("assemblerAissistTransform.refetchPrompts"),
			async callbackFunc() {
				await _t();
			}
		})), e.arePromptsInitialized = !!e.aissistPrompts.length;
	} catch {
		e.arePromptsInitialized = !1;
	} finally {
		e.isInitializingPrompts = !1;
	}
}, vt = Oe("aissistProviders", {
	state: () => ({
		areProvidersInitialized: !1,
		isInitializingProviders: !1,
		aissistProviders: []
	}),
	persist: !1
}), yt = async (e) => {
	let t = vt();
	if (t.isInitializingProviders || t.areProvidersInitialized) return;
	t.isInitializingProviders = !0;
	let n = De();
	try {
		t.aissistProviders = [...await Qe()], t.aissistProviders.length || n.showNotification(new H(e("assemblerAissistTransform.error.fetchProvidersNoDataInfo"), "info", {
			timeout: null,
			dismissible: !0,
			callbackLabel: e("assemblerAissistTransform.refetchProviders"),
			async callbackFunc() {
				t.areProvidersInitialized = !1, await yt(e);
			}
		})), t.areProvidersInitialized = !!t.aissistProviders.length;
	} catch {
		t.areProvidersInitialized = !1;
	} finally {
		t.isInitializingProviders = !1;
	}
};
//#endregion
//#region ../../../common/temp/node_modules/.pnpm/marked@13.0.3/node_modules/marked/lib/marked.esm.js
function bt() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var G = bt();
function xt(e) {
	G = e;
}
var St = /[&<>"']/, Ct = new RegExp(St.source, "g"), wt = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, Tt = new RegExp(wt.source, "g"), Et = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, Dt = (e) => Et[e];
function K(e, t) {
	if (t) {
		if (St.test(e)) return e.replace(Ct, Dt);
	} else if (wt.test(e)) return e.replace(Tt, Dt);
	return e;
}
var Ot = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
function kt(e) {
	return e.replace(Ot, (e, t) => (t = t.toLowerCase(), t === "colon" ? ":" : t.charAt(0) === "#" ? t.charAt(1) === "x" ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : ""));
}
var At = /(^|[^\[])\^/g;
function q(e, t) {
	let n = typeof e == "string" ? e : e.source;
	t ||= "";
	let r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace(At, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
function jt(e) {
	try {
		e = encodeURI(e).replace(/%25/g, "%");
	} catch {
		return null;
	}
	return e;
}
var Mt = { exec: () => null };
function Nt(e, t) {
	let n = e.replace(/\|/g, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(/ \|/), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n[n.length - 1].trim() && n.pop(), t) if (n.length > t) n.splice(t);
	else for (; n.length < t;) n.push("");
	for (; r < n.length; r++) n[r] = n[r].trim().replace(/\\\|/g, "|");
	return n;
}
function Pt(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r;) {
		let a = e.charAt(r - i - 1);
		if (a === t && !n) i++;
		else if (a !== t && n) i++;
		else break;
	}
	return e.slice(0, r - i);
}
function Ft(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return -1;
}
function It(e, t, n, r) {
	let i = t.href, a = t.title ? K(t.title) : null, o = e[1].replace(/\\([\[\]])/g, "$1");
	if (e[0].charAt(0) !== "!") {
		r.state.inLink = !0;
		let e = {
			type: "link",
			raw: n,
			href: i,
			title: a,
			text: o,
			tokens: r.inlineTokens(o)
		};
		return r.state.inLink = !1, e;
	}
	return {
		type: "image",
		raw: n,
		href: i,
		title: a,
		text: K(o)
	};
}
function Lt(e, t) {
	let n = e.match(/^(\s+)(?:```)/);
	if (n === null) return t;
	let r = n[1];
	return t.split("\n").map((e) => {
		let t = e.match(/^\s+/);
		if (t === null) return e;
		let [n] = t;
		return n.length >= r.length ? e.slice(r.length) : e;
	}).join("\n");
}
var Rt = class {
	options;
	rules;
	lexer;
	constructor(e) {
		this.options = e || G;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = t[0].replace(/^ {1,4}/gm, "");
			return {
				type: "code",
				raw: t[0],
				codeBlockStyle: "indented",
				text: this.options.pedantic ? e : Pt(e, "\n")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = Lt(e, t[3] || "");
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (/#$/.test(e)) {
				let t = Pt(e, "#");
				(this.options.pedantic || !t || / $/.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: t[0],
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: Pt(t[0], "\n")
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = Pt(t[0], "\n").split("\n"), n = "", r = "", i = [];
			for (; e.length > 0;) {
				let t = !1, a = [], o;
				for (o = 0; o < e.length; o++) if (/^ {0,3}>/.test(e[o])) a.push(e[o]), t = !0;
				else if (!t) a.push(e[o]);
				else break;
				e = e.slice(o);
				let s = a.join("\n"), c = s.replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, "\n    $1").replace(/^ {0,3}>[ \t]?/gm, "");
				n = n ? `${n}\n${s}` : s, r = r ? `${r}\n${c}` : c;
				let l = this.lexer.state.top;
				if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
				let u = i[i.length - 1];
				if (u?.type === "code") break;
				if (u?.type === "blockquote") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.blockquote(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - t.raw.length) + o.raw, r = r.substring(0, r.length - t.text.length) + o.text;
					break;
				} else if (u?.type === "list") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.list(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i[i.length - 1].raw.length).split("\n");
					continue;
				}
			}
			return {
				type: "blockquote",
				raw: n,
				tokens: i,
				text: r
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = RegExp(`^( {0,3}${n})((?:[\t ][^\\n]*)?(?:\\n|$))`), o = !1;
			for (; e;) {
				let n = !1, r = "", s = "";
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				r = t[0], e = e.substring(r.length);
				let c = t[2].split("\n", 1)[0].replace(/^\t+/, (e) => " ".repeat(3 * e.length)), l = e.split("\n", 1)[0], u = !c.trim(), d = 0;
				if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = t[2].search(/[^ ]/), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && /^ *$/.test(l) && (r += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = RegExp(`^ {0,${Math.min(3, d - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`), n = RegExp(`^ {0,${Math.min(3, d - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), i = RegExp(`^ {0,${Math.min(3, d - 1)}}(?:\`\`\`|~~~)`), a = RegExp(`^ {0,${Math.min(3, d - 1)}}#`);
					for (; e;) {
						let o = e.split("\n", 1)[0];
						if (l = o, this.options.pedantic && (l = l.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), i.test(l) || a.test(l) || t.test(l) || n.test(e)) break;
						if (l.search(/[^ ]/) >= d || !l.trim()) s += "\n" + l.slice(d);
						else {
							if (u || c.search(/[^ ]/) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
							s += "\n" + l;
						}
						!u && !l.trim() && (u = !0), r += o + "\n", e = e.substring(o.length + 1), c = l.slice(d);
					}
				}
				i.loose || (o ? i.loose = !0 : /\n *\n *$/.test(r) && (o = !0));
				let f = null, p;
				this.options.gfm && (f = /^\[[ xX]\] /.exec(s), f && (p = f[0] !== "[ ] ", s = s.replace(/^\[[ xX]\] +/, ""))), i.items.push({
					type: "list_item",
					raw: r,
					task: !!f,
					checked: p,
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += r;
			}
			i.items[i.items.length - 1].raw = i.items[i.items.length - 1].raw.trimEnd(), i.items[i.items.length - 1].text = i.items[i.items.length - 1].text.trimEnd(), i.raw = i.raw.trimEnd();
			for (let e = 0; e < i.items.length; e++) if (this.lexer.state.top = !1, i.items[e].tokens = this.lexer.blockTokens(i.items[e].text, []), !i.loose) {
				let t = i.items[e].tokens.filter((e) => e.type === "space");
				i.loose = t.length > 0 && t.some((e) => /\n.*\n/.test(e.raw));
			}
			if (i.loose) for (let e = 0; e < i.items.length; e++) i.items[e].loose = !0;
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) return {
			type: "html",
			block: !0,
			raw: t[0],
			pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
			text: t[0]
		};
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = t[1].toLowerCase().replace(/\s+/g, " "), n = t[2] ? t[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: t[0],
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !/[:|]/.test(t[2])) return;
		let n = Nt(t[1]), r = t[2].replace(/^\||\| *$/g, "").split("|"), i = t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split("\n") : [], a = {
			type: "table",
			raw: t[0],
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) /^ *-+: *$/.test(e) ? a.align.push("right") : /^ *:-+: *$/.test(e) ? a.align.push("center") : /^ *:-+ *$/.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e = 0; e < n.length; e++) a.header.push({
				text: n[e],
				tokens: this.lexer.inline(n[e]),
				header: !0,
				align: a.align[e]
			});
			for (let e of i) a.rows.push(Nt(e, a.header.length).map((e, t) => ({
				text: e,
				tokens: this.lexer.inline(e),
				header: !1,
				align: a.align[t]
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) return {
			type: "heading",
			raw: t[0],
			depth: t[2].charAt(0) === "=" ? 1 : 2,
			text: t[1],
			tokens: this.lexer.inline(t[1])
		};
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: K(t[1])
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let e = t[2].trim();
			if (!this.options.pedantic && /^</.test(e)) {
				if (!/>$/.test(e)) return;
				let t = Pt(e.slice(0, -1), "\\");
				if ((e.length - t.length) % 2 == 0) return;
			} else {
				let e = Ft(t[2], "()");
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let n = t[2], r = "";
			if (this.options.pedantic) {
				let e = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(n);
				e && (n = e[1], r = e[3]);
			} else r = t[3] ? t[3].slice(1, -1) : "";
			return n = n.trim(), /^</.test(n) && (n = this.options.pedantic && !/>$/.test(e) ? n.slice(1) : n.slice(1, -1)), It(t, {
				href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
				title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let e = t[(n[2] || n[1]).replace(/\s+/g, " ").toLowerCase()];
			if (!e) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return It(n, e, n[0], this.lexer);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (r && !(r[3] && n.match(/[\p{L}\p{N}]/u)) && (!(r[1] || r[2]) || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) != null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
				if (a = [...i].length, r[3] || r[4]) {
					o += a;
					continue;
				} else if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
					s += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o + s);
				let t = [...r[0]][0].length, c = e.slice(0, n + r.index + t + a);
				if (Math.min(n, a) % 2) {
					let e = c.slice(1, -1);
					return {
						type: "em",
						raw: c,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = c.slice(2, -2);
				return {
					type: "strong",
					raw: c,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(/\n/g, " "), n = /[^ ]/.test(e), r = /^ /.test(e) && / $/.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), e = K(e, !0), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e) {
		let t = this.rules.inline.del.exec(e);
		if (t) return {
			type: "del",
			raw: t[0],
			text: t[2],
			tokens: this.lexer.inlineTokens(t[2])
		};
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = K(t[1]), n = "mailto:" + e) : (e = K(t[1]), n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = K(t[0]), n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = K(t[0]), n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e;
			return e = this.lexer.state.inRawBlock ? t[0] : K(t[0]), {
				type: "text",
				raw: t[0],
				text: e
			};
		}
	}
}, zt = /^(?: *(?:\n|$))+/, Bt = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/, Vt = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, Ht = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Ut = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, Wt = /(?:[*+-]|\d{1,9}[.)])/, Gt = q(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, Wt).replace(/blockCode/g, / {4}/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex(), Kt = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, qt = /^[^\n]+/, Jt = /(?!\s*\])(?:\\.|[^\[\]\\])+/, Yt = q(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", Jt).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Xt = q(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, Wt).getRegex(), Zt = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", Qt = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, $t = q("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", Qt).replace("tag", Zt).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), en = q(Kt).replace("hr", Ht).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Zt).getRegex(), tn = {
	blockquote: q(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", en).getRegex(),
	code: Bt,
	def: Yt,
	fences: Vt,
	heading: Ut,
	hr: Ht,
	html: $t,
	lheading: Gt,
	list: Xt,
	newline: zt,
	paragraph: en,
	table: Mt,
	text: qt
}, nn = q("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", Ht).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Zt).getRegex(), rn = {
	...tn,
	table: nn,
	paragraph: q(Kt).replace("hr", Ht).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", nn).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Zt).getRegex()
}, an = {
	...tn,
	html: q("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", Qt).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: Mt,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: q(Kt).replace("hr", Ht).replace("heading", " *#{1,6} *[^\n]").replace("lheading", Gt).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, on = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, sn = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, cn = /^( {2,}|\\)\n(?!\s*$)/, ln = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, un = "\\p{P}\\p{S}", dn = q(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, un).getRegex(), fn = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g, pn = q(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, un).getRegex(), mn = q("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu").replace(/punct/g, un).getRegex(), hn = q("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu").replace(/punct/g, un).getRegex(), gn = q(/\\([punct])/, "gu").replace(/punct/g, un).getRegex(), _n = q(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), vn = q(Qt).replace("(?:-->|$)", "-->").getRegex(), yn = q("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", vn).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), bn = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, xn = q(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", bn).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), Sn = q(/^!?\[(label)\]\[(ref)\]/).replace("label", bn).replace("ref", Jt).getRegex(), Cn = q(/^!?\[(ref)\](?:\[\])?/).replace("ref", Jt).getRegex(), wn = {
	_backpedal: Mt,
	anyPunctuation: gn,
	autolink: _n,
	blockSkip: fn,
	br: cn,
	code: sn,
	del: Mt,
	emStrongLDelim: pn,
	emStrongRDelimAst: mn,
	emStrongRDelimUnd: hn,
	escape: on,
	link: xn,
	nolink: Cn,
	punctuation: dn,
	reflink: Sn,
	reflinkSearch: q("reflink|nolink(?!\\()", "g").replace("reflink", Sn).replace("nolink", Cn).getRegex(),
	tag: yn,
	text: ln,
	url: Mt
}, Tn = {
	...wn,
	link: q(/^!?\[(label)\]\((.*?)\)/).replace("label", bn).getRegex(),
	reflink: q(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", bn).getRegex()
}, En = {
	...wn,
	escape: q(on).replace("])", "~|])").getRegex(),
	url: q(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
	text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, Dn = {
	...En,
	br: q(cn).replace("{2,}", "*").getRegex(),
	text: q(En.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, On = {
	normal: tn,
	gfm: rn,
	pedantic: an
}, kn = {
	normal: wn,
	gfm: En,
	breaks: Dn,
	pedantic: Tn
}, J = class e {
	tokens;
	options;
	state;
	tokenizer;
	inlineQueue;
	constructor(e) {
		this.tokens = [], this.tokens.links = Object.create(null), this.options = e || G, this.options.tokenizer = this.options.tokenizer || new Rt(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			top: !0
		};
		let t = {
			block: On.normal,
			inline: kn.normal
		};
		this.options.pedantic ? (t.block = On.pedantic, t.inline = kn.pedantic) : this.options.gfm && (t.block = On.gfm, this.options.breaks ? t.inline = kn.breaks : t.inline = kn.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: On,
			inline: kn
		};
	}
	static lex(t, n) {
		return new e(n).lex(t);
	}
	static lexInline(t, n) {
		return new e(n).inlineTokens(t);
	}
	lex(e) {
		e = e.replace(/\r\n|\r/g, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = [], n = !1) {
		e = this.options.pedantic ? e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e.replace(/^( *)(\t+)/gm, (e, t, n) => t + "    ".repeat(n.length));
		let r, i, a;
		for (; e;) if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1))) {
			if (r = this.tokenizer.space(e)) {
				e = e.substring(r.raw.length), r.raw.length === 1 && t.length > 0 ? t[t.length - 1].raw += "\n" : t.push(r);
				continue;
			}
			if (r = this.tokenizer.code(e)) {
				e = e.substring(r.raw.length), i = t[t.length - 1], i && (i.type === "paragraph" || i.type === "text") ? (i.raw += "\n" + r.raw, i.text += "\n" + r.text, this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.fences(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.heading(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.hr(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.blockquote(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.list(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.html(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.def(e)) {
				e = e.substring(r.raw.length), i = t[t.length - 1], i && (i.type === "paragraph" || i.type === "text") ? (i.raw += "\n" + r.raw, i.text += "\n" + r.raw, this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
					href: r.href,
					title: r.title
				});
				continue;
			}
			if (r = this.tokenizer.table(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.lheading(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (a = e, this.options.extensions && this.options.extensions.startBlock) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startBlock.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (a = e.substring(0, t + 1));
			}
			if (this.state.top && (r = this.tokenizer.paragraph(a))) {
				i = t[t.length - 1], n && i?.type === "paragraph" ? (i.raw += "\n" + r.raw, i.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(r), n = a.length !== e.length, e = e.substring(r.raw.length);
				continue;
			}
			if (r = this.tokenizer.text(e)) {
				e = e.substring(r.raw.length), i = t[t.length - 1], i && i.type === "text" ? (i.raw += "\n" + r.raw, i.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(r);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				} else throw Error(t);
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	inlineTokens(e, t = []) {
		let n, r, i, a = e, o, s, c;
		if (this.tokens.links) {
			let e = Object.keys(this.tokens.links);
			if (e.length > 0) for (; (o = this.tokenizer.rules.inline.reflinkSearch.exec(a)) != null;) e.includes(o[0].slice(o[0].lastIndexOf("[") + 1, -1)) && (a = a.slice(0, o.index) + "[" + "a".repeat(o[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
		}
		for (; (o = this.tokenizer.rules.inline.blockSkip.exec(a)) != null;) a = a.slice(0, o.index) + "[" + "a".repeat(o[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		for (; (o = this.tokenizer.rules.inline.anyPunctuation.exec(a)) != null;) a = a.slice(0, o.index) + "++" + a.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		for (; e;) if (s || (c = ""), s = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((r) => (n = r.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
			if (n = this.tokenizer.escape(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.tag(e)) {
				e = e.substring(n.raw.length), r = t[t.length - 1], r && n.type === "text" && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
				continue;
			}
			if (n = this.tokenizer.link(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.reflink(e, this.tokens.links)) {
				e = e.substring(n.raw.length), r = t[t.length - 1], r && n.type === "text" && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
				continue;
			}
			if (n = this.tokenizer.emStrong(e, a, c)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.codespan(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.br(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.del(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.autolink(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (!this.state.inLink && (n = this.tokenizer.url(e))) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (i = e, this.options.extensions && this.options.extensions.startInline) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startInline.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (n = this.tokenizer.inlineText(i)) {
				e = e.substring(n.raw.length), n.raw.slice(-1) !== "_" && (c = n.raw.slice(-1)), s = !0, r = t[t.length - 1], r && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				} else throw Error(t);
			}
		}
		return t;
	}
}, An = class {
	options;
	parser;
	constructor(e) {
		this.options = e || G;
	}
	space(e) {
		return "";
	}
	code({ text: e, lang: t, escaped: n }) {
		let r = (t || "").match(/^\S*/)?.[0], i = e.replace(/\n$/, "") + "\n";
		return r ? "<pre><code class=\"language-" + K(r) + "\">" + (n ? i : K(i, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? i : K(i, !0)) + "</code></pre>\n";
	}
	blockquote({ tokens: e }) {
		return `<blockquote>\n${this.parser.parse(e)}</blockquote>\n`;
	}
	html({ text: e }) {
		return e;
	}
	heading({ tokens: e, depth: t }) {
		return `<h${t}>${this.parser.parseInline(e)}</h${t}>\n`;
	}
	hr(e) {
		return "<hr>\n";
	}
	list(e) {
		let t = e.ordered, n = e.start, r = "";
		for (let t = 0; t < e.items.length; t++) {
			let n = e.items[t];
			r += this.listitem(n);
		}
		let i = t ? "ol" : "ul", a = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + i + a + ">\n" + r + "</" + i + ">\n";
	}
	listitem(e) {
		let t = "";
		if (e.task) {
			let n = this.checkbox({ checked: !!e.checked });
			e.loose ? e.tokens.length > 0 && e.tokens[0].type === "paragraph" ? (e.tokens[0].text = n + " " + e.tokens[0].text, e.tokens[0].tokens && e.tokens[0].tokens.length > 0 && e.tokens[0].tokens[0].type === "text" && (e.tokens[0].tokens[0].text = n + " " + e.tokens[0].tokens[0].text)) : e.tokens.unshift({
				type: "text",
				raw: n + " ",
				text: n + " "
			}) : t += n + " ";
		}
		return t += this.parser.parse(e.tokens, !!e.loose), `<li>${t}</li>\n`;
	}
	checkbox({ checked: e }) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\">";
	}
	paragraph({ tokens: e }) {
		return `<p>${this.parser.parseInline(e)}</p>\n`;
	}
	table(e) {
		let t = "", n = "";
		for (let t = 0; t < e.header.length; t++) n += this.tablecell(e.header[t]);
		t += this.tablerow({ text: n });
		let r = "";
		for (let t = 0; t < e.rows.length; t++) {
			let i = e.rows[t];
			n = "";
			for (let e = 0; e < i.length; e++) n += this.tablecell(i[e]);
			r += this.tablerow({ text: n });
		}
		return r &&= `<tbody>${r}</tbody>`, "<table>\n<thead>\n" + t + "</thead>\n" + r + "</table>\n";
	}
	tablerow({ text: e }) {
		return `<tr>\n${e}</tr>\n`;
	}
	tablecell(e) {
		let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
		return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>\n`;
	}
	strong({ tokens: e }) {
		return `<strong>${this.parser.parseInline(e)}</strong>`;
	}
	em({ tokens: e }) {
		return `<em>${this.parser.parseInline(e)}</em>`;
	}
	codespan({ text: e }) {
		return `<code>${e}</code>`;
	}
	br(e) {
		return "<br>";
	}
	del({ tokens: e }) {
		return `<del>${this.parser.parseInline(e)}</del>`;
	}
	link({ href: e, title: t, tokens: n }) {
		let r = this.parser.parseInline(n), i = jt(e);
		if (i === null) return r;
		e = i;
		let a = "<a href=\"" + e + "\"";
		return t && (a += " title=\"" + t + "\""), a += ">" + r + "</a>", a;
	}
	image({ href: e, title: t, text: n }) {
		let r = jt(e);
		if (r === null) return n;
		e = r;
		let i = `<img src="${e}" alt="${n}"`;
		return t && (i += ` title="${t}"`), i += ">", i;
	}
	text(e) {
		return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : e.text;
	}
}, jn = class {
	strong({ text: e }) {
		return e;
	}
	em({ text: e }) {
		return e;
	}
	codespan({ text: e }) {
		return e;
	}
	del({ text: e }) {
		return e;
	}
	html({ text: e }) {
		return e;
	}
	text({ text: e }) {
		return e;
	}
	link({ text: e }) {
		return "" + e;
	}
	image({ text: e }) {
		return "" + e;
	}
	br() {
		return "";
	}
}, Mn = class e {
	options;
	renderer;
	textRenderer;
	constructor(e) {
		this.options = e || G, this.options.renderer = this.options.renderer || new An(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new jn();
	}
	static parse(t, n) {
		return new e(n).parse(t);
	}
	static parseInline(t, n) {
		return new e(n).parseInline(t);
	}
	parse(e, t = !0) {
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
				let e = i, t = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (t !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"paragraph",
					"text"
				].includes(e.type)) {
					n += t || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "space":
					n += this.renderer.space(a);
					continue;
				case "hr":
					n += this.renderer.hr(a);
					continue;
				case "heading":
					n += this.renderer.heading(a);
					continue;
				case "code":
					n += this.renderer.code(a);
					continue;
				case "table":
					n += this.renderer.table(a);
					continue;
				case "blockquote":
					n += this.renderer.blockquote(a);
					continue;
				case "list":
					n += this.renderer.list(a);
					continue;
				case "html":
					n += this.renderer.html(a);
					continue;
				case "paragraph":
					n += this.renderer.paragraph(a);
					continue;
				case "text": {
					let i = a, o = this.renderer.text(i);
					for (; r + 1 < e.length && e[r + 1].type === "text";) i = e[++r], o += "\n" + this.renderer.text(i);
					t ? n += this.renderer.paragraph({
						type: "paragraph",
						raw: o,
						text: o,
						tokens: [{
							type: "text",
							raw: o,
							text: o
						}]
					}) : n += o;
					continue;
				}
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
	parseInline(e, t) {
		t ||= this.renderer;
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "escape":
					n += t.text(a);
					break;
				case "html":
					n += t.html(a);
					break;
				case "link":
					n += t.link(a);
					break;
				case "image":
					n += t.image(a);
					break;
				case "strong":
					n += t.strong(a);
					break;
				case "em":
					n += t.em(a);
					break;
				case "codespan":
					n += t.codespan(a);
					break;
				case "br":
					n += t.br(a);
					break;
				case "del":
					n += t.del(a);
					break;
				case "text":
					n += t.text(a);
					break;
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, Nn = class {
	options;
	constructor(e) {
		this.options = e || G;
	}
	static passThroughHooks = new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
}, Pn = new class {
	defaults = bt();
	options = this.setOptions;
	parse = this.#t(J.lex, Mn.parse);
	parseInline = this.#t(J.lexInline, Mn.parseInline);
	Parser = Mn;
	Renderer = An;
	TextRenderer = jn;
	Lexer = J;
	Tokenizer = Rt;
	Hooks = Nn;
	constructor(...e) {
		this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new An(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (["options", "parser"].includes(n)) continue;
					let r = n, i = e.renderer[r];
					e.useNewRenderer || (i = this.#e(i, r, t));
					let a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new Rt(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new Nn();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (n === "options") continue;
					let r = n, i = e.hooks[r], a = t[r];
					Nn.passThroughHooks.has(n) ? t[r] = (e) => {
						if (this.defaults.async) return Promise.resolve(i.call(t, e)).then((e) => a.call(t, e));
						let n = i.call(t, e);
						return a.call(t, n);
					} : t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	#e(e, t, n) {
		switch (t) {
			case "heading": return function(r) {
				return !r.type || r.type !== t ? e.apply(this, arguments) : e.call(this, n.parser.parseInline(r.tokens), r.depth, kt(n.parser.parseInline(r.tokens, n.parser.textRenderer)));
			};
			case "code": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, n.text, n.lang, !!n.escaped);
			};
			case "table": return function(n) {
				if (!n.type || n.type !== t) return e.apply(this, arguments);
				let r = "", i = "";
				for (let e = 0; e < n.header.length; e++) i += this.tablecell({
					text: n.header[e].text,
					tokens: n.header[e].tokens,
					header: !0,
					align: n.align[e]
				});
				r += this.tablerow({ text: i });
				let a = "";
				for (let e = 0; e < n.rows.length; e++) {
					let t = n.rows[e];
					i = "";
					for (let e = 0; e < t.length; e++) i += this.tablecell({
						text: t[e].text,
						tokens: t[e].tokens,
						header: !1,
						align: n.align[e]
					});
					a += this.tablerow({ text: i });
				}
				return e.call(this, r, a);
			};
			case "blockquote": return function(n) {
				if (!n.type || n.type !== t) return e.apply(this, arguments);
				let r = this.parser.parse(n.tokens);
				return e.call(this, r);
			};
			case "list": return function(n) {
				if (!n.type || n.type !== t) return e.apply(this, arguments);
				let r = n.ordered, i = n.start, a = n.loose, o = "";
				for (let e = 0; e < n.items.length; e++) {
					let t = n.items[e], r = t.checked, i = t.task, s = "";
					if (t.task) {
						let e = this.checkbox({ checked: !!r });
						a ? t.tokens.length > 0 && t.tokens[0].type === "paragraph" ? (t.tokens[0].text = e + " " + t.tokens[0].text, t.tokens[0].tokens && t.tokens[0].tokens.length > 0 && t.tokens[0].tokens[0].type === "text" && (t.tokens[0].tokens[0].text = e + " " + t.tokens[0].tokens[0].text)) : t.tokens.unshift({
							type: "text",
							text: e + " "
						}) : s += e + " ";
					}
					s += this.parser.parse(t.tokens, a), o += this.listitem({
						type: "list_item",
						raw: s,
						text: s,
						task: i,
						checked: !!r,
						loose: a,
						tokens: t.tokens
					});
				}
				return e.call(this, o, r, i);
			};
			case "html": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, n.text, n.block);
			};
			case "paragraph": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, this.parser.parseInline(n.tokens));
			};
			case "escape": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, n.text);
			};
			case "link": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, n.href, n.title, this.parser.parseInline(n.tokens));
			};
			case "image": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, n.href, n.title, n.text);
			};
			case "strong": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, this.parser.parseInline(n.tokens));
			};
			case "em": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, this.parser.parseInline(n.tokens));
			};
			case "codespan": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, n.text);
			};
			case "del": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, this.parser.parseInline(n.tokens));
			};
			case "text": return function(n) {
				return !n.type || n.type !== t ? e.apply(this, arguments) : e.call(this, n.text);
			};
		}
		return e;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return J.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return Mn.parse(e, t ?? this.defaults);
	}
	#t(e, t) {
		return (n, r) => {
			let i = { ...r }, a = {
				...this.defaults,
				...i
			};
			this.defaults.async === !0 && i.async === !1 && (a.silent || console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored."), a.async = !0);
			let o = this.#n(!!a.silent, !!a.async);
			if (n == null) return o(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof n != "string") return o(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
			if (a.hooks && (a.hooks.options = a), a.async) return Promise.resolve(a.hooks ? a.hooks.preprocess(n) : n).then((t) => e(t, a)).then((e) => a.hooks ? a.hooks.processAllTokens(e) : e).then((e) => a.walkTokens ? Promise.all(this.walkTokens(e, a.walkTokens)).then(() => e) : e).then((e) => t(e, a)).then((e) => a.hooks ? a.hooks.postprocess(e) : e).catch(o);
			try {
				a.hooks && (n = a.hooks.preprocess(n));
				let r = e(n, a);
				a.hooks && (r = a.hooks.processAllTokens(r)), a.walkTokens && this.walkTokens(r, a.walkTokens);
				let i = t(r, a);
				return a.hooks && (i = a.hooks.postprocess(i)), i;
			} catch (e) {
				return o(e);
			}
		};
	}
	#n(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + K(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}();
function Y(e, t) {
	return Pn.parse(e, t);
}
Y.options = Y.setOptions = function(e) {
	return Pn.setOptions(e), Y.defaults = Pn.defaults, xt(Y.defaults), Y;
}, Y.getDefaults = bt, Y.defaults = G, Y.use = function(...e) {
	return Pn.use(...e), Y.defaults = Pn.defaults, xt(Y.defaults), Y;
}, Y.walkTokens = function(e, t) {
	return Pn.walkTokens(e, t);
}, Y.parseInline = Pn.parseInline, Y.Parser = Mn, Y.parser = Mn.parse, Y.Renderer = An, Y.TextRenderer = jn, Y.Lexer = J, Y.lexer = J.lex, Y.Tokenizer = Rt, Y.Hooks = Nn, Y.parse = Y, Y.options, Y.setOptions, Y.use, Y.walkTokens, Y.parseInline, Mn.parse, J.lex;
//#endregion
//#region ../../../common/temp/node_modules/.pnpm/turndown@7.2.4/node_modules/turndown/lib/turndown.browser.es.js
function Fn(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t];
		for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
	}
	return e;
}
function In(e, t) {
	return Array(t + 1).join(e);
}
function Ln(e) {
	return e.replace(/^\n*/, "");
}
function Rn(e) {
	for (var t = e.length; t > 0 && e[t - 1] === "\n";) t--;
	return e.substring(0, t);
}
function zn(e) {
	return Rn(Ln(e));
}
var Bn = /* @__PURE__ */ "ADDRESS.ARTICLE.ASIDE.AUDIO.BLOCKQUOTE.BODY.CANVAS.CENTER.DD.DIR.DIV.DL.DT.FIELDSET.FIGCAPTION.FIGURE.FOOTER.FORM.FRAMESET.H1.H2.H3.H4.H5.H6.HEADER.HGROUP.HR.HTML.ISINDEX.LI.MAIN.MENU.NAV.NOFRAMES.NOSCRIPT.OL.OUTPUT.P.PRE.SECTION.TABLE.TBODY.TD.TFOOT.TH.THEAD.TR.UL".split(".");
function Vn(e) {
	return Jn(e, Bn);
}
var Hn = [
	"AREA",
	"BASE",
	"BR",
	"COL",
	"COMMAND",
	"EMBED",
	"HR",
	"IMG",
	"INPUT",
	"KEYGEN",
	"LINK",
	"META",
	"PARAM",
	"SOURCE",
	"TRACK",
	"WBR"
];
function Un(e) {
	return Jn(e, Hn);
}
function Wn(e) {
	return Yn(e, Hn);
}
var Gn = [
	"A",
	"TABLE",
	"THEAD",
	"TBODY",
	"TFOOT",
	"TH",
	"TD",
	"IFRAME",
	"SCRIPT",
	"AUDIO",
	"VIDEO"
];
function Kn(e) {
	return Jn(e, Gn);
}
function qn(e) {
	return Yn(e, Gn);
}
function Jn(e, t) {
	return t.indexOf(e.nodeName) >= 0;
}
function Yn(e, t) {
	return e.getElementsByTagName && t.some(function(t) {
		return e.getElementsByTagName(t).length;
	});
}
var Xn = [
	[/\\/g, "\\\\"],
	[/\*/g, "\\*"],
	[/^-/g, "\\-"],
	[/^\+ /g, "\\+ "],
	[/^(=+)/g, "\\$1"],
	[/^(#{1,6}) /g, "\\$1 "],
	[/`/g, "\\`"],
	[/^~~~/g, "\\~~~"],
	[/\[/g, "\\["],
	[/\]/g, "\\]"],
	[/^>/g, "\\>"],
	[/_/g, "\\_"],
	[/^(\d+)\. /g, "$1\\. "]
];
function Zn(e) {
	return Xn.reduce(function(e, t) {
		return e.replace(t[0], t[1]);
	}, e);
}
var X = {};
X.paragraph = {
	filter: "p",
	replacement: function(e) {
		return "\n\n" + e + "\n\n";
	}
}, X.lineBreak = {
	filter: "br",
	replacement: function(e, t, n) {
		return n.br + "\n";
	}
}, X.heading = {
	filter: [
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6"
	],
	replacement: function(e, t, n) {
		var r = Number(t.nodeName.charAt(1));
		if (n.headingStyle === "setext" && r < 3) {
			var i = In(r === 1 ? "=" : "-", e.length);
			return "\n\n" + e + "\n" + i + "\n\n";
		} else return "\n\n" + In("#", r) + " " + e + "\n\n";
	}
}, X.blockquote = {
	filter: "blockquote",
	replacement: function(e) {
		return e = zn(e).replace(/^/gm, "> "), "\n\n" + e + "\n\n";
	}
}, X.list = {
	filter: ["ul", "ol"],
	replacement: function(e, t) {
		var n = t.parentNode;
		return n.nodeName === "LI" && n.lastElementChild === t ? "\n" + e : "\n\n" + e + "\n\n";
	}
}, X.listItem = {
	filter: "li",
	replacement: function(e, t, n) {
		var r = n.bulletListMarker + "   ", i = t.parentNode;
		if (i.nodeName === "OL") {
			var a = i.getAttribute("start"), o = Array.prototype.indexOf.call(i.children, t);
			r = (a ? Number(a) + o : o + 1) + ".  ";
		}
		var s = /\n$/.test(e);
		return e = zn(e) + (s ? "\n" : ""), e = e.replace(/\n/gm, "\n" + " ".repeat(r.length)), r + e + (t.nextSibling ? "\n" : "");
	}
}, X.indentedCodeBlock = {
	filter: function(e, t) {
		return t.codeBlockStyle === "indented" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
	},
	replacement: function(e, t, n) {
		return "\n\n    " + t.firstChild.textContent.replace(/\n/g, "\n    ") + "\n\n";
	}
}, X.fencedCodeBlock = {
	filter: function(e, t) {
		return t.codeBlockStyle === "fenced" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
	},
	replacement: function(e, t, n) {
		for (var r = ((t.firstChild.getAttribute("class") || "").match(/language-(\S+)/) || [null, ""])[1], i = t.firstChild.textContent, a = n.fence.charAt(0), o = 3, s = RegExp("^" + a + "{3,}", "gm"), c; c = s.exec(i);) c[0].length >= o && (o = c[0].length + 1);
		var l = In(a, o);
		return "\n\n" + l + r + "\n" + i.replace(/\n$/, "") + "\n" + l + "\n\n";
	}
}, X.horizontalRule = {
	filter: "hr",
	replacement: function(e, t, n) {
		return "\n\n" + n.hr + "\n\n";
	}
}, X.inlineLink = {
	filter: function(e, t) {
		return t.linkStyle === "inlined" && e.nodeName === "A" && e.getAttribute("href");
	},
	replacement: function(e, t) {
		var n = $n(t.getAttribute("href")), r = er(Qn(t.getAttribute("title"))), i = r ? " \"" + r + "\"" : "";
		return "[" + e + "](" + n + i + ")";
	}
}, X.referenceLink = {
	filter: function(e, t) {
		return t.linkStyle === "referenced" && e.nodeName === "A" && e.getAttribute("href");
	},
	replacement: function(e, t, n) {
		var r = $n(t.getAttribute("href")), i = Qn(t.getAttribute("title"));
		i &&= " \"" + er(i) + "\"";
		var a, o;
		switch (n.linkReferenceStyle) {
			case "collapsed":
				a = "[" + e + "][]", o = "[" + e + "]: " + r + i;
				break;
			case "shortcut":
				a = "[" + e + "]", o = "[" + e + "]: " + r + i;
				break;
			default:
				var s = this.references.length + 1;
				a = "[" + e + "][" + s + "]", o = "[" + s + "]: " + r + i;
		}
		return this.references.push(o), a;
	},
	references: [],
	append: function(e) {
		var t = "";
		return this.references.length && (t = "\n\n" + this.references.join("\n") + "\n\n", this.references = []), t;
	}
}, X.emphasis = {
	filter: ["em", "i"],
	replacement: function(e, t, n) {
		return e.trim() ? n.emDelimiter + e + n.emDelimiter : "";
	}
}, X.strong = {
	filter: ["strong", "b"],
	replacement: function(e, t, n) {
		return e.trim() ? n.strongDelimiter + e + n.strongDelimiter : "";
	}
}, X.code = {
	filter: function(e) {
		var t = e.previousSibling || e.nextSibling, n = e.parentNode.nodeName === "PRE" && !t;
		return e.nodeName === "CODE" && !n;
	},
	replacement: function(e) {
		if (!e) return "";
		e = e.replace(/\r?\n|\r/g, " ");
		for (var t = /^`|^ .*?[^ ].* $|`$/.test(e) ? " " : "", n = "`", r = e.match(/`+/gm) || []; r.indexOf(n) !== -1;) n += "`";
		return n + t + e + t + n;
	}
}, X.image = {
	filter: "img",
	replacement: function(e, t) {
		var n = Zn(Qn(t.getAttribute("alt"))), r = $n(t.getAttribute("src") || ""), i = Qn(t.getAttribute("title")), a = i ? " \"" + er(i) + "\"" : "";
		return r ? "![" + n + "](" + r + a + ")" : "";
	}
};
function Qn(e) {
	return e ? e.replace(/(\n+\s*)+/g, "\n") : "";
}
function $n(e) {
	var t = e.replace(/([<>()])/g, "\\$1");
	return t.indexOf(" ") >= 0 ? "<" + t + ">" : t;
}
function er(e) {
	return e.replace(/"/g, "\\\"");
}
function tr(e) {
	for (var t in this.options = e, this._keep = [], this._remove = [], this.blankRule = { replacement: e.blankReplacement }, this.keepReplacement = e.keepReplacement, this.defaultRule = { replacement: e.defaultReplacement }, this.array = [], e.rules) this.array.push(e.rules[t]);
}
tr.prototype = {
	add: function(e, t) {
		this.array.unshift(t);
	},
	keep: function(e) {
		this._keep.unshift({
			filter: e,
			replacement: this.keepReplacement
		});
	},
	remove: function(e) {
		this._remove.unshift({
			filter: e,
			replacement: function() {
				return "";
			}
		});
	},
	forNode: function(e) {
		if (e.isBlank) return this.blankRule;
		var t;
		return (t = nr(this.array, e, this.options)) || (t = nr(this._keep, e, this.options)) || (t = nr(this._remove, e, this.options)) ? t : this.defaultRule;
	},
	forEach: function(e) {
		for (var t = 0; t < this.array.length; t++) e(this.array[t], t);
	}
};
function nr(e, t, n) {
	for (var r = 0; r < e.length; r++) {
		var i = e[r];
		if (rr(i, t, n)) return i;
	}
}
function rr(e, t, n) {
	var r = e.filter;
	if (typeof r == "string") {
		if (r === t.nodeName.toLowerCase()) return !0;
	} else if (Array.isArray(r)) {
		if (r.indexOf(t.nodeName.toLowerCase()) > -1) return !0;
	} else if (typeof r == "function") {
		if (r.call(e, t, n)) return !0;
	} else throw TypeError("`filter` needs to be a string, array, or function");
}
function ir(e) {
	var t = e.element, n = e.isBlock, r = e.isVoid, i = e.isPre || function(e) {
		return e.nodeName === "PRE";
	};
	if (!(!t.firstChild || i(t))) {
		for (var a = null, o = !1, s = null, c = or(s, t, i); c !== t;) {
			if (c.nodeType === 3 || c.nodeType === 4) {
				var l = c.data.replace(/[ \r\n\t]+/g, " ");
				if ((!a || / $/.test(a.data)) && !o && l[0] === " " && (l = l.substr(1)), !l) {
					c = ar(c);
					continue;
				}
				c.data = l, a = c;
			} else if (c.nodeType === 1) n(c) || c.nodeName === "BR" ? (a && (a.data = a.data.replace(/ $/, "")), a = null, o = !1) : r(c) || i(c) ? (a = null, o = !0) : a && (o = !1);
			else {
				c = ar(c);
				continue;
			}
			var u = or(s, c, i);
			s = c, c = u;
		}
		a && (a.data = a.data.replace(/ $/, ""), a.data || ar(a));
	}
}
function ar(e) {
	var t = e.nextSibling || e.parentNode;
	return e.parentNode.removeChild(e), t;
}
function or(e, t, n) {
	return e && e.parentNode === t || n(t) ? t.nextSibling || t.parentNode : t.firstChild || t.nextSibling || t.parentNode;
}
var sr = typeof window < "u" ? window : {};
function cr() {
	var e = sr.DOMParser, t = !1;
	try {
		new e().parseFromString("", "text/html") && (t = !0);
	} catch {}
	return t;
}
function lr() {
	var e = function() {};
	return ur() ? e.prototype.parseFromString = function(e) {
		var t = new window.ActiveXObject("htmlfile");
		return t.designMode = "on", t.open(), t.write(e), t.close(), t;
	} : e.prototype.parseFromString = function(e) {
		var t = document.implementation.createHTMLDocument("");
		return t.open(), t.write(e), t.close(), t;
	}, e;
}
function ur() {
	var e = !1;
	try {
		document.implementation.createHTMLDocument("").open();
	} catch {
		sr.ActiveXObject && (e = !0);
	}
	return e;
}
var dr = cr() ? sr.DOMParser : lr();
function fr(e, t) {
	var n = typeof e == "string" ? mr().parseFromString("<x-turndown id=\"turndown-root\">" + e + "</x-turndown>", "text/html").getElementById("turndown-root") : e.cloneNode(!0);
	return ir({
		element: n,
		isBlock: Vn,
		isVoid: Un,
		isPre: t.preformattedCode ? hr : null
	}), n;
}
var pr;
function mr() {
	return pr ||= new dr(), pr;
}
function hr(e) {
	return e.nodeName === "PRE" || e.nodeName === "CODE";
}
function gr(e, t) {
	return e.isBlock = Vn(e), e.isCode = e.nodeName === "CODE" || e.parentNode.isCode, e.isBlank = _r(e), e.flankingWhitespace = vr(e, t), e;
}
function _r(e) {
	return !Un(e) && !Kn(e) && /^\s*$/i.test(e.textContent) && !Wn(e) && !qn(e);
}
function vr(e, t) {
	if (e.isBlock || t.preformattedCode && e.isCode) return {
		leading: "",
		trailing: ""
	};
	var n = yr(e.textContent);
	return n.leadingAscii && br("left", e, t) && (n.leading = n.leadingNonAscii), n.trailingAscii && br("right", e, t) && (n.trailing = n.trailingNonAscii), {
		leading: n.leading,
		trailing: n.trailing
	};
}
function yr(e) {
	var t = e.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
	return {
		leading: t[1],
		leadingAscii: t[2],
		leadingNonAscii: t[3],
		trailing: t[4],
		trailingNonAscii: t[5],
		trailingAscii: t[6]
	};
}
function br(e, t, n) {
	var r, i, a;
	return e === "left" ? (r = t.previousSibling, i = / $/) : (r = t.nextSibling, i = /^ /), r && (r.nodeType === 3 ? a = i.test(r.nodeValue) : n.preformattedCode && r.nodeName === "CODE" ? a = !1 : r.nodeType === 1 && !Vn(r) && (a = i.test(r.textContent))), a;
}
var xr = Array.prototype.reduce;
function Sr(e) {
	if (!(this instanceof Sr)) return new Sr(e);
	var t = {
		rules: X,
		headingStyle: "setext",
		hr: "* * *",
		bulletListMarker: "*",
		codeBlockStyle: "indented",
		fence: "```",
		emDelimiter: "_",
		strongDelimiter: "**",
		linkStyle: "inlined",
		linkReferenceStyle: "full",
		br: "  ",
		preformattedCode: !1,
		blankReplacement: function(e, t) {
			return t.isBlock ? "\n\n" : "";
		},
		keepReplacement: function(e, t) {
			return t.isBlock ? "\n\n" + t.outerHTML + "\n\n" : t.outerHTML;
		},
		defaultReplacement: function(e, t) {
			return t.isBlock ? "\n\n" + e + "\n\n" : e;
		}
	};
	this.options = Fn({}, t, e), this.rules = new tr(this.options);
}
Sr.prototype = {
	turndown: function(e) {
		if (!Dr(e)) throw TypeError(e + " is not a string, or an element/document/fragment node.");
		if (e === "") return "";
		var t = Cr.call(this, new fr(e, this.options));
		return wr.call(this, t);
	},
	use: function(e) {
		if (Array.isArray(e)) for (var t = 0; t < e.length; t++) this.use(e[t]);
		else if (typeof e == "function") e(this);
		else throw TypeError("plugin must be a Function or an Array of Functions");
		return this;
	},
	addRule: function(e, t) {
		return this.rules.add(e, t), this;
	},
	keep: function(e) {
		return this.rules.keep(e), this;
	},
	remove: function(e) {
		return this.rules.remove(e), this;
	},
	escape: function(e) {
		return Zn(e);
	}
};
function Cr(e) {
	var t = this;
	return xr.call(e.childNodes, function(e, n) {
		n = new gr(n, t.options);
		var r = "";
		return n.nodeType === 3 ? r = n.isCode ? n.nodeValue : t.escape(n.nodeValue) : n.nodeType === 1 && (r = Tr.call(t, n)), Er(e, r);
	}, "");
}
function wr(e) {
	var t = this;
	return this.rules.forEach(function(n) {
		typeof n.append == "function" && (e = Er(e, n.append(t.options)));
	}), e.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function Tr(e) {
	var t = this.rules.forNode(e), n = Cr.call(this, e), r = e.flankingWhitespace;
	return (r.leading || r.trailing) && (n = n.trim()), r.leading + t.replacement(n, e, this.options) + r.trailing;
}
function Er(e, t) {
	var n = Rn(e), r = Ln(t), i = Math.max(e.length - n.length, t.length - r.length);
	return n + "\n\n".substring(0, i) + r;
}
function Dr(e) {
	return e != null && (typeof e == "string" || e.nodeType && (e.nodeType === 1 || e.nodeType === 9 || e.nodeType === 11));
}
//#endregion
//#region src/utils/aissist.ts
var Or = /* @__PURE__ */ function(e) {
	return e.HTML = "html", e.MARKDOWN = "markdown", e;
}({}), kr = /* @__PURE__ */ function(e) {
	return e.REPHRASE = "rephrase", e.TRANSLATE = "translate", e.SEO = "seo", e.OPTIMIZE = "optimize", e;
}({}), Ar = /* @__PURE__ */ function(e) {
	return e.ARTICLE = "article", e.TRANSCRIPT = "transcript", e;
}({}), jr = (e, t) => `${e}:${t}`, Mr = "type:default", Nr = /* @__PURE__ */ function(e) {
	return e.TARGET = "target:", e.BRAND = "brand:", e;
}({});
function Pr(e) {
	return [e === "markdown" ? "Gib den transformierten Artikel ausschließlich in Markdown zurück: keine HTML-Tags, keine Code-Fences. Der Lead (erster Absatz) ist Klartext ohne Markdown-Formatierung." : "Gib den transformierten Artikel ausschließlich in HTML zurück: dieselbe Blockstruktur wie der Input, Lead in einem <p>-Element (Klartext), danach der Inhalt. Keine Wrapper-Tags (<html>, <body>, <article>) und keine Markdown-Syntax.", "Behalte '<<< PLACEHOLDER >>>' in Anzahl, Reihenfolge und Schreibweise exakt bei."].join("\n");
}
function Fr(e, t) {
	let n = ["Du transformierst Artikeltexte für einen CMS-Redakteur."], r = t?.trim();
	return r && (n.push(`<base_task>\n${r}\n</base_task>`), n.push("Wende den Basis-Auftrag auf den gesamten Artikel an (Lead und Inhalt). Bewahre die inhaltliche Korrektheit; erfinde keine Fakten.")), n.push(`<technical_rules>\n${e.trim()}\n</technical_rules>`), n.join("\n\n");
}
function Ir(e, t) {
	return [
		"Du passt einen bereits transformierten Artikelentwurf für einen CMS-Redakteur an.",
		`<base_task>\n${t.trim()}\n</base_task>`,
		"Nimm nur die angeforderten Änderungen vor; belasse alles andere unverändert, soweit möglich.",
		`<technical_rules>\n${e.trim()}\n</technical_rules>`
	].join("\n\n");
}
function Lr(e) {
	let t = e.trim(), n = t.match(/^```(?:html|markdown|md)?\s*\r?\n([\s\S]*?)\r?\n```$/i);
	n?.[1] && (t = n[1].trim());
	let r = t.match(/^<article>\s*([\s\S]*?)\s*<\/article>$/i);
	return r?.[1] && (t = r[1].trim()), t;
}
function Rr(e) {
	let t = new Sr({ headingStyle: "atx" });
	return t.addRule("paragraph", {
		filter: "p",
		replacement: function(e) {
			return e + "\n\n";
		}
	}), t.turndown(e);
}
async function zr(e) {
	return await Y.parse(e);
}
function Br(e, t) {
	let n = e.leadText ? `<p>${e.leadText}</p>` : "";
	for (let t of e.blocks) t.origin === "text" ? n += t.content : n += "<<< PLACEHOLDER >>>";
	return t === "markdown" && (n = Rr(n)), n;
}
async function Vr(e, t, n) {
	let r = e.blocks.filter((e) => e.origin !== "text"), i = Lr(t), a = Ae(n === "markdown" ? await zr(i) : i), o, s = /<p>(.+?)<\/p>/m, c = a.match(s);
	Array.isArray(c) && c.length > 0 && (o = je(c[1])), a = a.replace(s, "");
	let l = a.split(/(<<< PLACEHOLDER >>>)/), u = 0, d = [];
	for (let e of l) {
		let t = r[u];
		e === "<<< PLACEHOLDER >>>" && t ? (d.push(t), u++) : e.trim().length && d.push({
			origin: "text",
			content: e
		});
	}
	return {
		...e,
		leadText: o || e.leadText,
		blocks: d
	};
}
function Hr(e) {
	return (e.allowedBrands || []).filter((t) => !e.linkedContentsRef?.some((e) => e.brand === t));
}
//#endregion
//#region src/utils/aissist-document.ts
var Ur = Symbol("importTransformedDoc");
function Wr(e) {
	let t = [], n = [];
	for (let r of e.content ?? []) r.type === "TEXT" ? t.push({
		origin: "text",
		content: r.content
	}) : r.type === "PARTNER" ? n.push({
		origin: "assembler",
		block: r
	}) : t.push({
		origin: "assembler",
		block: r
	});
	return {
		id: e._id,
		leadText: e.leadText,
		blocks: t,
		trailingBlocks: n.length ? n : void 0,
		assemblerDoc: e
	};
}
function Gr(e) {
	let t = [];
	for (let n of [...e.blocks, ...e.trailingBlocks ?? []]) if (n.origin === "text") {
		let e = {
			type: "TEXT",
			content: n.content
		};
		t.push(e);
	} else n.origin === "assembler" && t.push(n.block);
	return {
		...e.assemblerDoc,
		_id: e.id ?? e.assemblerDoc?._id,
		leadText: e.leadText,
		content: t
	};
}
function Kr(e, t) {
	return e.flatMap((e, n) => {
		if (e.type !== "PARTNER") return [];
		let r = t[n];
		return r?.type === "TEXT" && typeof r.content == "string" ? [r.content] : [];
	});
}
function qr(e) {
	let t = e.trailingTextContents ?? [], n = new Set(t), r = [], i = t.map((e) => ({
		origin: "text",
		content: e
	}));
	for (let t of e.contentsRef ?? []) {
		let e = Reflect.get(t, "content");
		if (t.type === "TEXT" && typeof e == "string") {
			if (n.has(e)) continue;
			r.push({
				origin: "text",
				content: e
			});
			continue;
		}
		r.push({
			origin: "ctf",
			block: t
		});
	}
	return {
		id: e.id,
		leadText: e.leadText,
		blocks: r,
		trailingBlocks: i.length ? i : void 0
	};
}
function Jr(e) {
	let t = [];
	for (let n of [...e.blocks, ...e.trailingBlocks ?? []]) if (n.origin === "text") {
		let e = {
			type: "TEXT",
			content: n.content
		};
		t.push(e);
	} else n.origin === "ctf" && t.push(n.block);
	return t;
}
//#endregion
//#region src/utils/block-preview.ts
var Yr = {
	CTA: "Call to action",
	CTA_BUTTON: "CTA button"
};
function Z(e, t) {
	let n = Reflect.get(e, t);
	return typeof n == "string" ? n : "";
}
function Xr(e) {
	return Yr[e] || e.split("_").map((e) => e.charAt(0) + e.slice(1).toLowerCase()).join(" ");
}
function Zr(e) {
	switch (e.type) {
		case "CTA": return Z(e, "title") || Z(e, "buttonText") || Z(e, "text");
		case "VIDEO": return Z(e, "videoTeaser");
		case "SOCIAL": return [Z(e, "socialName"), Z(e, "accountName")].filter(Boolean).join(" · ");
		case "WIDGET_MODULE": return Z(e, "title");
		case "BACKGROUND_ARTICLE": return Z(e, "teaser");
		case "ARTICLE": return Z(e, "articleTeaser");
		case "ARTICLES_BOX": return Z(e, "tableOfContentsText");
		case "IMAGE": return Z(e, "additionalCaption");
		default: return "";
	}
}
//#endregion
//#region src/utils/import-history.ts
function Qr(e, t) {
	if (!e) return;
	if (e.mainImage === t) return e.mainImage;
	let n = e.content?.find((e) => e === t);
	return n?.type === "IMAGE" ? n : e.mainImage?.source === t.source ? e.mainImage : e.content?.find((e) => e.type === "IMAGE" && e.source === t.source);
}
function $r(e, t) {
	return Qr(e, t)?.assetId ?? t.assetId;
}
function ei(e, t) {
	let n = $r(e, t);
	if (e && n) {
		let t = [...e.ctfMeta?.importHistory ?? []].sort((e, t) => t.version - e.version);
		for (let e of t) {
			let t = e.assets.find((e) => e.assetId === n && e.ctfAssetUuid);
			if (t?.ctfAssetUuid) return t.ctfAssetUuid;
		}
	}
}
function ti(e, t) {
	let n = e.version ?? 1, r = e.ctfMeta?.importHistory?.find((e) => e.version === n)?.assets ?? [];
	return {
		version: n,
		createDate: (/* @__PURE__ */ new Date()).toISOString(),
		assets: [...r.filter((e) => e.assetId !== t.assetId), t]
	};
}
function ni(e, t) {
	return [...(e ?? []).filter((e) => e.version !== t.version), t];
}
function ri(e, t, n) {
	return Qr(e, t) === e.mainImage || e.mainImage?.assetId === n ? "teaser" : "inline";
}
//#endregion
//#region src/utils/image-display.ts
var ii = /* @__PURE__ */ new Map();
function ai(e) {
	let t = ii.get(e);
	return t || (t = Ne.getEntity(e, { handleError: !1 }).then(() => !0).catch(() => !1), ii.set(e, t)), t;
}
async function oi(e, t, n, r) {
	let i = t ? ei(e, t) : void 0;
	if (i && await ai(i)) return Fe(i, n, r);
}
//#endregion
//#region src/utils/locking.ts
function si(e, t) {
	return `${e}:${t}`;
}
function ci(e, t) {
	let n = e?.[t];
	return n ? !!(n.locked && !n.isOwnLock) : !1;
}
function li(e, t, n, r, i) {
	let a = e?.[t];
	return a?.locked && !a?.isOwnLock ? `${r(n)} (${i} ${a.ownerName})` : r(n);
}
//#endregion
//#region src/utils/preview.ts
function Q(e) {
	if (e !== void 0) return e.replace(/[“”„‟«»]/g, "\"");
}
function ui(e) {
	let t = { ...e };
	return [
		"title",
		"seoTitle",
		"kicker",
		"leadText"
	].forEach((e) => {
		t[e] && (t[e] = Q(t[e]) || t[e]);
	}), t.content?.forEach((e) => {
		if (e.type === "TEXT" || e.type === "PARTNER") e.content = Q(e.content) || e.content;
		else if (e.type === "QUOTE") e.quote = Q(e.quote) || e.quote;
		else return;
	}), t;
}
//#endregion
//#region src/utils/social.ts
function di(e, t, n) {
	let r = document.createElement("script");
	r.id = e, r.src = t, n && (r.crossOrigin = n), r.defer = !0, document.body.appendChild(r);
}
//#endregion
//#region src/components/aissist/transform/aissist-prompt.select.vue?vue&type=script&setup=true&lang.ts
var fi = { class: "aissist-prompt-select-field__value ellipsis no-highlight" }, pi = { class: "aissist-prompt-select-menu-container" }, mi = { class: "aissist-prompt-select-menu-container__search q-pa-sm" }, hi = /* @__PURE__ */ k({
	__name: "aissist-prompt.select",
	props: /* @__PURE__ */ A({
		filterTags: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let n = t, { t: r } = U(), i = z(t, "modelValue"), a = F(""), o = F(), c = F(!1);
		function u(e) {
			e && n.disable || (c.value = e);
		}
		function te() {
			n.disable || u(!c.value);
		}
		let ne = S(() => i.value?.name?.trim() || r("assemblerAissistTransform.promptSelectPlaceholder"));
		function g() {
			a.value = "";
		}
		function re(e) {
			i.value = { ...e }, u(!1), g();
		}
		async function _() {
			await fe(), o.value?.focus();
		}
		let v = gt(), { getPromptTemplate: ie } = v, ae = S(() => n.filterTags?.find((e) => e.startsWith(Nr.TARGET)));
		function y(e) {
			let t = ae.value;
			return t ? e.tags?.some((e) => e.name === t) ?? !1 : !0;
		}
		function oe(e) {
			let t = n.filterTags;
			return t?.length ? t.every((t) => t.startsWith(Nr.BRAND) && !e.tags?.some((e) => e.name?.startsWith(Nr.BRAND)) ? !0 : e.tags?.some((e) => e.name === t) ?? !1) : !1;
		}
		let b = S(() => {
			let e = a.value.toLowerCase(), t = v.aissistPrompts.filter((t) => t.name?.toLowerCase().includes(e)).filter(y);
			return {
				match: t.filter(oe),
				other: t.filter((e) => !oe(e))
			};
		});
		B(() => n.disable, (e) => {
			e && u(!1);
		});
		function se() {
			let e = n.filterTags?.find((e) => e.startsWith(Nr.BRAND));
			if (!e || !v.arePromptsInitialized) return;
			let t = v.aissistPrompts.filter(y).filter(oe).filter((e) => e.tags?.some((e) => e.name === Mr)), r = t.find((t) => t.tags?.some((t) => t.name === e)) ?? t[0];
			r ? i.value = { ...r } : i.value = ie();
		}
		return B(() => [n.filterTags, v.arePromptsInitialized], se), (n, i) => (P(), T("div", {
			class: "aissist-prompt-select full-width",
			"data-qa-aissist-prompt-select": "",
			onClick: te
		}, [O(R(s), {
			class: j(["aissist-prompt-select-field q-select full-width", { "cursor-pointer": !t.disable }]),
			label: R(r)("assemblerAissistTransform.prompt"),
			outlined: "",
			dense: "",
			"stack-label": "",
			disable: t.disable
		}, {
			control: V(() => [E("div", fi, L(ne.value), 1)]),
			append: V(() => [O(R(l), {
				name: "keyboard_arrow_down",
				class: j(["aissist-prompt-select-field__arrow", { "aissist-prompt-select-field__arrow--open": c.value }])
			}, null, 8, ["class"])]),
			_: 1
		}, 8, [
			"class",
			"label",
			"disable"
		]), O(R(ee), {
			"model-value": c.value,
			fit: "",
			"no-parent-event": "",
			class: "aissist-prompt-select-menu",
			"data-qa-aissist-prompt-select-menu": "",
			anchor: "bottom left",
			self: "top left",
			"onUpdate:modelValue": u,
			onShow: _,
			onHide: g
		}, {
			default: V(() => [E("div", pi, [E("div", mi, [O(R(d), {
				ref_key: "searchRef",
				ref: o,
				modelValue: a.value,
				"onUpdate:modelValue": i[0] ||= (e) => a.value = e,
				class: "full-width",
				label: R(r)("assemblerAissistTransform.searchPrompts"),
				dense: "",
				outlined: "",
				clearable: "",
				onClear: g,
				onClick: i[1] ||= ye(() => {}, ["stop"])
			}, null, 8, ["modelValue", "label"])]), O(R(h), { class: "prompts-list-container" }, {
				default: V(() => [
					b.value.match.length ? (P(), C(R(f), {
						key: "header-match",
						class: "dropdown-section-header text-weight-bold text-capitalize",
						dense: ""
					}, {
						default: V(() => [O(R(m), null, {
							default: V(() => [D(L(R(r)("assemblerAissistTransform.matchingPrompts")) + " (" + L(b.value.match.length) + ") ", 1)]),
							_: 1
						})]),
						_: 1
					})) : w("", !0),
					(P(!0), T(x, null, _e(b.value.match, (t) => ve((P(), C(R(f), {
						key: t.name,
						clickable: "",
						onClick: (e) => re(t)
					}, {
						default: V(() => [O(R(m), null, {
							default: V(() => [O(R(p), { "data-qa-assembler-prompt-match-select": t.name }, {
								default: V(() => [D(L(t.name), 1)]),
								_: 2
							}, 1032, ["data-qa-assembler-prompt-match-select"])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, ["onClick"])), [[R(e)]])), 128)),
					b.value.other.length ? (P(), C(R(f), {
						key: "header-other",
						class: "dropdown-section-header text-weight-bold text-capitalize",
						dense: ""
					}, {
						default: V(() => [O(R(m), null, {
							default: V(() => [D(L(R(r)("assemblerAissistTransform.otherPrompts")) + " (" + L(b.value.other.length) + ") ", 1)]),
							_: 1
						})]),
						_: 1
					})) : w("", !0),
					(P(!0), T(x, null, _e(b.value.other, (t) => ve((P(), C(R(f), {
						key: t.name,
						clickable: "",
						onClick: (e) => re(t)
					}, {
						default: V(() => [O(R(m), null, {
							default: V(() => [O(R(p), { "data-qa-assembler-prompt-other-select": t.name }, {
								default: V(() => [D(L(t.name), 1)]),
								_: 2
							}, 1032, ["data-qa-assembler-prompt-other-select"])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, ["onClick"])), [[R(e)]])), 128))
				]),
				_: 1
			})])]),
			_: 1
		}, 8, ["model-value"])]));
	}
}), $ = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, gi = /* @__PURE__ */ $(hi, [["__scopeId", "data-v-df3c7c68"]]), _i = /* @__PURE__ */ k({
	__name: "aissist-transform.prompt-textarea.input",
	props: /* @__PURE__ */ A({
		label: {},
		rows: { default: 5 },
		hideExpandToggle: { type: Boolean },
		clearable: { type: Boolean },
		disable: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: { required: !1 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = z(e, "modelValue"), { t: n } = U(), r = F(!1), i = F(null);
		function a() {
			r.value = !r.value, r.value || fe(() => {
				let e = i.value?.getNativeElement?.();
				e instanceof HTMLTextAreaElement && (e.style.overflowY = "");
			});
		}
		return (o, s) => (P(), C(R(d), {
			ref_key: "systemPromptInputRef",
			ref: i,
			modelValue: t.value,
			"onUpdate:modelValue": s[1] ||= (e) => t.value = e,
			filled: "",
			type: "textarea",
			rows: e.rows,
			label: e.label,
			autogrow: r.value,
			clearable: e.clearable,
			disable: e.disable
		}, ce({ _: 2 }, [e.hideExpandToggle ? void 0 : {
			name: "prepend",
			fn: V(() => [O(R(l), {
				name: r.value ? "expand_less" : "expand_more",
				class: j({ "cursor-pointer": !e.disable }),
				"data-qa-aissist-input-prompt-autogrow-toggle": "",
				onClick: s[0] ||= ye((t) => !e.disable && a(), ["stop"])
			}, {
				default: V(() => [O(R(y), null, {
					default: V(() => [D(L(r.value ? R(n)("assemblerAissistTransform.promptInputTooltip.minimize") : R(n)("assemblerAissistTransform.promptInputTooltip.expand")), 1)]),
					_: 1
				})]),
				_: 1
			}, 8, ["name", "class"])]),
			key: "0"
		}]), 1032, [
			"modelValue",
			"rows",
			"label",
			"autogrow",
			"clearable",
			"disable"
		]));
	}
}), vi = /* @__PURE__ */ k({
	__name: "aissist-transform-provider.selector",
	props: {
		provider: {},
		providerModifiers: {}
	},
	emits: ["update:provider"],
	setup(e) {
		let t = z(e, "provider"), { t: n } = U(), r = vt(), i = S(() => r.aissistProviders.map((e) => ({
			value: e.name,
			label: e.display_name || e.name
		})));
		return N(() => {
			yt(n);
		}), (e, a) => (P(), C(R(ne), {
			modelValue: t.value,
			"onUpdate:modelValue": a[0] ||= (e) => t.value = e,
			"data-qa-aissist-provider-select": "",
			options: i.value,
			loading: R(r).isInitializingProviders,
			disable: R(r).isInitializingProviders || !R(r).areProvidersInitialized,
			"emit-value": "",
			"map-options": "",
			"option-value": "value",
			"option-label": "label",
			label: R(n)("assemblerAissistTransform.provider.label"),
			dense: "",
			outlined: "",
			"dropdown-icon": "expand_more"
		}, null, 8, [
			"modelValue",
			"options",
			"loading",
			"disable",
			"label"
		]));
	}
}), yi = { class: "aissist-transform-additional-configs-wrapper" }, bi = {
	class: "q-pa-md",
	"data-qa-aissist-additional-settings-panel": ""
}, xi = /* @__PURE__ */ k({
	__name: "aissist-transform-additional-settings.container",
	props: /* @__PURE__ */ A({ disable: { type: Boolean } }, {
		prompt: { required: !0 },
		promptModifiers: {},
		showAdditionalSettings: {
			type: Boolean,
			required: !0
		},
		showAdditionalSettingsModifiers: {}
	}),
	emits: /* @__PURE__ */ A(["reset-prompt"], ["update:prompt", "update:showAdditionalSettings"]),
	setup(e, { emit: t }) {
		let n = z(e, "prompt"), r = z(e, "showAdditionalSettings"), i = t, { t: o } = U(), s = (e) => {
			r.value = e, e || i("reset-prompt");
		};
		return (t, i) => (P(), T("div", yi, [O(R(a), {
			"model-value": r.value,
			"data-qa-aissist-additional-settings-checkbox": "",
			label: R(o)("assemblerAissistTransform.additionalSettings"),
			disable: e.disable,
			"onUpdate:modelValue": s
		}, null, 8, [
			"model-value",
			"label",
			"disable"
		]), r.value ? (P(), T(x, { key: 0 }, [O(R(g)), E("div", bi, [O(vi, {
			provider: n.value.provider,
			"onUpdate:provider": i[0] ||= (e) => n.value.provider = e
		}, null, 8, ["provider"])])], 64)) : w("", !0)]));
	}
}), Si = { class: "assembler-preview-cta-button-wrapper" }, Ci = {
	key: 0,
	class: "assembler-preview-cta-button-image-wrapper"
}, wi = { class: "row justify-center q-pb-md" }, Ti = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "assembler-preview.cta-button",
	props: { ctaButtonBlock: {} },
	setup(e) {
		let t = e, { t: r } = U(), i = () => ({
			...Re(),
			label: r("assemblerPreview.ctaButtonLoading")
		}), a = F(i()), o = F(), s = F(!1), c = async () => {
			if (a.value = i(), s.value = !1, t.ctaButtonBlock) try {
				if (a.value = await Le(t.ctaButtonBlock.ctaButtonUuid), a.value.imageUuid) {
					let e = await Pe(a.value.imageUuid);
					o.value = Fe(e.image._id, e.image.width, e.image.height);
				}
			} catch {
				s.value = !0, a.value = {
					...a.value,
					label: r("assemblerPreview.ctaButtonLoadingFailed")
				};
			}
		};
		N(c), B(() => t.ctaButtonBlock, (e) => e.ctaButtonUuid !== a.value._id && c());
		let l = S(() => s.value ? "negative" : a.value.layoutType === "primary" ? "black" : "orange-9");
		return (e, t) => (P(), T("div", Si, [o.value ? (P(), T("div", Ci, [O(R(u), {
			class: "full-width full-height",
			src: o.value
		}, null, 8, ["src"])])) : w("", !0), E("div", wi, [O(R(n), {
			label: a.value.label,
			color: l.value,
			href: a.value.link,
			target: "_blank",
			"icon-right": s.value ? "warning" : "chevron-right",
			class: j({ "cta-button": o.value })
		}, null, 8, [
			"label",
			"color",
			"href",
			"icon-right",
			"class"
		])])]));
	}
}), [["__scopeId", "data-v-ccb0a150"]]), Ei = { class: "ca-preview-gallery-wrapper q-my-sm" }, Di = { class: "absolute-bottom gallery-image-info q-pa-md" }, Oi = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "assembler-preview.gallery",
	props: { galleryBlock: {} },
	setup(e) {
		let { t } = U(), n = F(0);
		return (a, o) => (P(), T("div", Ei, [O(R(r), {
			modelValue: n.value,
			"onUpdate:modelValue": o[0] ||= (e) => n.value = e,
			animated: "",
			arrows: "",
			"control-type": "regular",
			"control-color": "primary",
			"control-text-color": "white",
			infinite: ""
		}, {
			default: V(() => [(P(!0), T(x, null, _e(e.galleryBlock.images, (e, n) => (P(), C(R(i), {
				key: n,
				name: n,
				"img-src": e.source
			}, {
				default: V(() => [E("div", Di, [E("div", { class: j(["ca-preview-image-caption text-caption text-center q-pt-xs", { "text-red": !e.caption }]) }, L(e.caption || R(t)("assemblerPreview.missingCaption")), 3), E("div", { class: j(["ca-preview-image-credits text-caption text-center q-pt-xs", { "text-red": !e.credits }]) }, L(e.credits || R(t)("assemblerPreview.missingCredits")), 3)])]),
				_: 2
			}, 1032, ["name", "img-src"]))), 128))]),
			_: 1
		}, 8, ["modelValue"])]));
	}
}), [["__scopeId", "data-v-c06f89f9"]]), ki = /* @__PURE__ */ k({
	__name: "assembler-image-import.dialog",
	props: {
		ctfImageUuid: {},
		onImageSave: { type: Function }
	},
	emits: [...b.emits],
	setup(e) {
		let { dialogRef: t, onDialogCancel: n } = b();
		return (r, i) => (P(), C(R(o), {
			ref_key: "dialogRef",
			ref: t,
			"full-width": "",
			"full-height": "",
			onHide: R(n)
		}, {
			default: V(() => [O(R(Me), {
				id: e.ctfImageUuid,
				dialog: !0,
				"onBack:clicked": R(n),
				"onBack:modal": R(n),
				onSave: e.onImageSave
			}, null, 8, [
				"id",
				"onBack:clicked",
				"onBack:modal",
				"onSave"
			])]),
			_: 1
		}, 8, ["onHide"]));
	}
}), Ai = /* @__PURE__ */ k({
	__name: "assembler-image-import.button",
	props: /* @__PURE__ */ A({ imageBlock: {} }, {
		previewDoc: {},
		previewDocModifiers: {}
	}),
	emits: ["update:previewDoc"],
	setup(e) {
		let { t } = U(), r = De(), { showDialog: i } = Ee(), a = e, o = z(e, "previewDoc"), s = S(() => ei(o.value, a.imageBlock)), c = S(() => $r(o.value, a.imageBlock));
		function l() {
			r.showNotification(new H(t("assemblerPreview.imageImportMissingAssetId")));
		}
		async function u(e) {
			let t = e[0];
			if (!t || !o.value?._id) return;
			let n = c.value;
			if (!n) {
				l();
				return;
			}
			let r = ri(o.value, a.imageBlock, n), i = ti(o.value, {
				assetId: n,
				role: r,
				ctfAssetUuid: t
			});
			await rt(o.value._id, i), o.value.ctfMeta = {
				...o.value.ctfMeta,
				importHistory: ni(o.value.ctfMeta?.importHistory, i)
			};
		}
		let d = S(() => s.value ? "edit" : "download"), f = S(() => s.value ? t("assemblerPreview.imageEditTooltip") : t("assemblerPreview.imageImportTooltip")), p = (e) => i(new xe({
			component: ki,
			componentProps: {
				ctfImageUuid: e,
				imageBlock: a.imageBlock,
				onImageSave: e ? () => {} : u
			}
		})), m = async () => {
			try {
				let e = await fetch(a.imageBlock.source), t = await e.blob(), n = e.headers.get("Content-Type") || "image/jpeg", r = n.split("/")[1] || "jpg", i = new File([t], `importImage.${r}`, { type: n }), { source: s, title: c, alt: l, caption: u, credits: d, height: f, width: m } = a.imageBlock;
				Ie({
					source: s,
					title: c || u || o.value?.title || "",
					alt: l,
					caption: u,
					credits: d,
					height: f,
					width: m
				}, i), p();
			} catch {
				r.showNotification(new H(t("assemblerPreview.imageImportError")));
			}
		}, h = async () => {
			let e = s.value;
			if (e) try {
				await Pe(e), p(e);
				return;
			} catch {}
			if (!c.value) {
				l();
				return;
			}
			m();
		};
		return (e, t) => (P(), C(R(n), {
			icon: d.value,
			round: "",
			dense: "",
			flat: "",
			color: "white",
			class: "absolute-top-right q-ma-sm bg-primary",
			onClick: h
		}, {
			default: V(() => [O(R(y), {
				anchor: "top middle",
				self: "bottom middle"
			}, {
				default: V(() => [D(L(f.value), 1)]),
				_: 1
			})]),
			_: 1
		}, 8, ["icon"]));
	}
}), ji = { class: "ca-preview-image-wrapper" }, Mi = {
	class: "ca-preview-image-media",
	style: { position: "relative" }
}, Ni = {
	key: 0,
	"data-qa-assembler-preview-image-loading": "",
	class: "flex flex-center assembler-preview-image-loading",
	style: { "min-height": "150px" }
}, Pi = {
	key: 1,
	"data-qa-assembler-preview-image-error": "",
	class: "assembler-preview-image-error-wrapper flex flex-center bg-white text-black text-center q-pa-md"
}, Fi = { "data-qa-assembler-preview-image-error-message": "" }, Ii = {
	key: 0,
	class: "row q-gutter-x-sm justify-center items-center full-width"
}, Li = 1200, Ri = 800, zi = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "assembler-preview.image",
	props: /* @__PURE__ */ A({
		imageBlock: {},
		isImageImportDisabled: {
			type: Boolean,
			default: !1
		}
	}, {
		previewDoc: {},
		previewDocModifiers: {}
	}),
	emits: ["update:previewDoc"],
	setup(e) {
		let t = [
			"image/avif",
			"image/gif",
			"image/jpeg",
			"image/png",
			"image/webp"
		], n = [
			"image/png",
			"image/jpeg",
			"image/gif"
		], { t: r } = U(), i = z(e, "previewDoc"), a = e, o = F(""), s = F(!0), c = F(!1), d = F(null), f = F(!1), p = !0, m = 0, h = () => {
			o.value.startsWith("blob:") && URL.revokeObjectURL(o.value), o.value = "";
		}, ee = async (e, i) => {
			if (f.value = !1, c.value = !1, h(), !e) {
				if (!p || i !== m) return;
				d.value = r("assemblerPreview.missingImageSource"), s.value = !1;
				return;
			}
			try {
				let a = await fetch(e);
				if (!p || i !== m) return;
				if (!a.ok) {
					d.value = r("assemblerPreview.imageFetchFailed", { status: a.status });
					return;
				}
				let s = a.headers.get("content-type")?.split(";")[0]?.trim().toLowerCase();
				if (!s || !t.includes(s)) {
					await a.body?.cancel(), d.value = r("assemblerPreview.unsupportedFormat");
					return;
				}
				let l = await a.blob();
				if (!p || i !== m) return;
				o.value = URL.createObjectURL(l), c.value = n.includes(s);
			} catch {
				if (!p || i !== m) return;
				o.value = e;
			} finally {
				p && i === m && (s.value = !1);
			}
		}, te = async () => {
			let e = ++m;
			s.value = !0, d.value = null;
			let t = await oi(i.value, a.imageBlock, Li, Ri);
			if (!(!p || e !== m)) {
				if (t) {
					h(), o.value = t, c.value = !0, f.value = !0, s.value = !1;
					return;
				}
				await ee(a.imageBlock?.source, e);
			}
		}, ne = () => {
			if (!(s.value || !o.value || d.value)) {
				if (f.value) {
					let e = ++m;
					s.value = !0, d.value = null, ee(a.imageBlock.source, e);
					return;
				}
				d.value = r("assemblerPreview.imageLoadError"), h();
			}
		};
		return B(() => [
			i.value?.ctfMeta,
			a.imageBlock?.source,
			a.imageBlock?.assetId
		], () => {
			te();
		}, { immediate: !0 }), me(() => {
			p = !1, h();
		}), (t, n) => (P(), T("div", ji, [E("div", Mi, [s.value ? (P(), T("div", Ni, [O(R(_), {
			color: "primary",
			size: "2em"
		})])) : d.value ? (P(), T("div", Pi, [E("div", null, [O(R(l), {
			name: "warning",
			size: "2rem",
			class: "q-mb-xs"
		}), E("div", Fi, L(d.value), 1)])])) : o.value ? (P(), C(R(u), {
			key: 2,
			"data-qa-assembler-preview-image": "",
			src: o.value,
			fit: "cover",
			onError: ne
		}, null, 8, ["src"])) : w("", !0), e.imageBlock.isImportableInVibe && !e.isImageImportDisabled && !d.value && c.value ? (P(), C(Ai, {
			key: 3,
			"preview-doc": i.value,
			"onUpdate:previewDoc": n[0] ||= (e) => i.value = e,
			"image-block": e.imageBlock
		}, null, 8, ["preview-doc", "image-block"])) : w("", !0)]), d.value ? w("", !0) : (P(), T("div", Ii, [E("div", { class: j(["ca-preview-image-caption text-caption text-center q-pt-xs", { "text-red": !e.imageBlock.caption }]) }, L(e.imageBlock.caption || R(r)("assemblerPreview.missingCaption")), 3), E("div", { class: j(["ca-preview-image-credits text-caption text-center q-pt-xs", { "text-red": !e.imageBlock.credits }]) }, L(e.imageBlock.credits || R(r)("assemblerPreview.missingCredits")), 3)]))]));
	}
}), [["__scopeId", "data-v-a2147636"]]), Bi = { class: "assembler-preview-newsletter q-pa-sm q-mb-md" }, Vi = { class: "row items-center q-gutter-sm" }, Hi = { class: "text-body1" }, Ui = {
	key: 0,
	class: "text-subtitle2 q-mt-xs"
}, Wi = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "assembler-preview.newsletter",
	props: { newsletterBlock: {} },
	setup(e) {
		let t = e, { t: n } = U(), r = () => ({
			...ze(),
			title: n("assemblerPreview.newsletterLoading")
		}), i = F(r()), a = async () => {
			if (i.value = r(), t.newsletterBlock) try {
				i.value = await Be(t.newsletterBlock.newsletterUuid);
			} catch {
				i.value = {
					...i.value,
					title: n("assemblerPreview.newsletterLoadingFailed"),
					headline: void 0
				};
			}
		};
		return N(a), B(() => t.newsletterBlock, (e) => e.newsletterUuid !== i.value._id && a()), (e, t) => (P(), T("div", Bi, [E("div", Vi, [O(R(l), {
			name: "mail",
			size: "20px",
			color: "primary"
		}), E("div", Hi, L(i.value.title), 1)]), i.value.headline ? (P(), T("div", Ui, L(i.value.headline), 1)) : w("", !0)]));
	}
}), [["__scopeId", "data-v-5c0fc665"]]), Gi = { class: "reusable-text-assembler-preview q-pa-sm q-mb-md" }, Ki = ["innerHTML"], qi = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "assembler-preview.reusable-text",
	props: { reusableTextBlock: {} },
	setup(e) {
		let t = e, { t: n } = U(), r = () => ({
			...Ve(),
			textContent: `<p>${n("assemblerPreview.reusableTextLoading")}<p>`
		}), i = F(r()), a = F(!1), o = F(!1), s = () => {
			o.value = !0, a.value = !1;
		}, c = (e = !1) => {
			o.value = !0, a.value = e;
		}, l = async () => {
			if (s(), i.value = r(), t.reusableTextBlock) try {
				i.value = await He(t.reusableTextBlock.reusableTextUuid), c();
			} catch {
				c(!0), i.value = {
					...i.value,
					textContent: `<h2>${n("assemblerPreview.reusableTextLoadingFailed")}<h2>`
				};
			}
			else c(!0);
		};
		return N(l), B(() => t.reusableTextBlock, (e) => e.reusableTextUuid !== i.value._id && l()), (e, t) => (P(), T("div", Gi, [E("div", {
			class: "text-container",
			innerHTML: i.value.textContent
		}, null, 8, Ki)]));
	}
}), [["__scopeId", "data-v-e29960a7"]]), Ji = { class: "facebook-post-container" }, Yi = ["data-href"], Xi = ["data-href"], Zi = /* @__PURE__ */ k({
	__name: "facebook-social.block",
	props: { socialBlock: {} },
	setup(e) {
		return N(() => {
			window.FB ? window.FB.XFBML.parse() : (delete window.FB, di("facebook_script", "//connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v7.0"));
		}), (t, n) => (P(), T("div", Ji, [
			n[0] ||= E("div", { id: "fb-root" }, null, -1),
			e.socialBlock.embedType === "posts" ? (P(), T("div", {
				key: 0,
				class: "fb-post",
				"data-href": e.socialBlock.postUrl
			}, null, 8, Yi)) : w("", !0),
			e.socialBlock.embedType === "videos" ? (P(), T("div", {
				key: 1,
				class: "fb-video",
				"data-href": e.socialBlock.postUrl,
				"data-width": "500",
				"data-show-text": "false",
				"data-allowfullscreen": "true",
				"data-autoplay": "false",
				"data-show-captions": "true"
			}, null, 8, Xi)) : w("", !0)
		]));
	}
}), Qi = { class: "instagram-post-container row justify-center q-pa-sm" }, $i = { class: "q-pa-md" }, ea = { class: "q-my-md flex justify-center items-center" }, ta = {
	class: "instagram-icon",
	viewBox: "0 0 60 60",
	xmlns: "http://www.w3.org/2000/svg",
	style: {
		height: "50px",
		width: "50px"
	}
}, na = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "instagram-social.block",
	props: { socialBlock: {} },
	setup(e) {
		let t = `https://www.instagram.com/p/${e.socialBlock.postId}/?utm_source=ig_embed&amp;utm_campaign=loading`;
		return N(() => {
			window.instgrm ? window.instgrm.Embeds.process() : di("instagram_script", "//www.instagram.com/embed.js");
		}), (e, n) => (P(), T("div", Qi, [E("blockquote", {
			class: "instagram-media q-pa-none q-border-radius-md shadow-2",
			"data-instgrm-permalink": t,
			"data-instgrm-version": "14"
		}, [E("div", $i, [E("a", {
			href: t,
			class: "instagram-link text-center",
			target: "_blank"
		}, [
			n[1] ||= le("<div class=\"q-gutter-sm flex items-center\" data-v-d20e5d99><div class=\"skeleton-block rounded-full\" style=\"height:40px;width:40px;\" data-v-d20e5d99></div><div class=\"q-gutter-xs\" data-v-d20e5d99><div class=\"skeleton-block rounded-sm\" style=\"height:14px;width:100px;\" data-v-d20e5d99></div><div class=\"skeleton-block rounded-sm\" style=\"height:14px;width:60px;\" data-v-d20e5d99></div></div></div><div class=\"q-mt-md\" style=\"padding-top:19%;\" data-v-d20e5d99></div>", 2),
			E("div", ea, [(P(), T("svg", ta, [...n[0] ||= [E("g", {
				stroke: "none",
				fill: "none",
				"fill-rule": "evenodd"
			}, [E("g", {
				transform: "translate(-511.000000, -20.000000)",
				fill: "currentColor"
			}, [E("g", null, [E("path", { d: "M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631" })])])], -1)]]))]),
			n[2] ||= le("<div class=\"q-my-sm text-primary text-caption text-bold\" data-v-d20e5d99>View this post on Instagram</div><div class=\"q-mt-md\" data-v-d20e5d99><div class=\"q-gutter-sm flex items-center\" data-v-d20e5d99><div class=\"skeleton-block rounded-full\" style=\"height:12.5px;width:12.5px;\" data-v-d20e5d99></div><div class=\"skeleton-block rounded-full\" style=\"height:12.5px;width:12.5px;transform:translateX(9px) translateY(-18px);\" data-v-d20e5d99></div></div></div><div class=\"q-mt-lg q-gutter-sm\" data-v-d20e5d99><div class=\"skeleton-block rounded-sm\" style=\"height:14px;width:224px;\" data-v-d20e5d99></div><div class=\"skeleton-block rounded-sm\" style=\"height:14px;width:144px;\" data-v-d20e5d99></div></div>", 3)
		])])])]));
	}
}), [["__scopeId", "data-v-d20e5d99"]]), ra = { class: "tiktok-post-container" }, ia = ["cite", "data-video-id"], aa = ["cite", "data-unique-id"], oa = /* @__PURE__ */ k({
	__name: "tiktok-social.block",
	props: { socialBlock: {} },
	setup(e) {
		return N(() => {
			di("tikTok_script", "//www.tiktok.com/embed.js");
		}), (t, n) => (P(), T("div", ra, [e.socialBlock.embedType === "video" ? (P(), T("blockquote", {
			key: 0,
			class: "tiktok-embed",
			cite: e.socialBlock.postUrl,
			"data-video-id": e.socialBlock.postId,
			style: {
				"max-width": "605px",
				"min-width": "325px"
			}
		}, [...n[0] ||= [E("section", null, null, -1)]], 8, ia)) : w("", !0), e.socialBlock.embedType === "photo" ? (P(), T("blockquote", {
			key: 1,
			class: "tiktok-embed",
			cite: e.socialBlock.postUrl,
			"data-unique-id": e.socialBlock.accountName,
			"data-embed-type": "creator",
			style: {
				"max-width": "780px",
				"min-width": "288px"
			}
		}, [...n[1] ||= [E("section", null, null, -1)]], 8, aa)) : w("", !0)]));
	}
}), sa = { class: "twitter-post-container" }, ca = { class: "twitter-tweet" }, la = ["href"], ua = /* @__PURE__ */ k({
	__name: "twitter-social.block",
	props: { socialBlock: {} },
	setup(e) {
		return N(() => {
			if (window.twttr) return window.twttr.widgets.load();
			di("twitter_script", "https://platform.twitter.com/widgets.js");
		}), (t, n) => (P(), T("div", sa, [E("blockquote", ca, [E("a", { href: `https://twitter.com/${e.socialBlock.accountName}/status/${e.socialBlock.postId}` }, null, 8, la)])]));
	}
}), da = { class: "youtube-video-container" }, fa = [
	"cite",
	"data-video-id",
	"data-short-id"
], pa = ["src"], ma = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "youtube-social.block",
	props: { socialBlock: {} },
	setup(e) {
		return (t, n) => (P(), T("div", da, [E("blockquote", {
			class: j(e.socialBlock.embedType === "video" ? "youtube-video" : "youtube-shorts"),
			cite: e.socialBlock.postUrl,
			"data-video-id": e.socialBlock.embedType === "video" ? e.socialBlock.postId : void 0,
			"data-short-id": e.socialBlock.embedType === "short" ? e.socialBlock.postId : void 0
		}, [E("iframe", {
			src: `https://www.youtube.com/embed/${e.socialBlock.postId}?feature=oembed`,
			style: {
				width: "100%",
				height: "100%"
			},
			frameborder: "0",
			referrerpolicy: "strict-origin-when-cross-origin",
			allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
			allowfullscreen: ""
		}, null, 8, pa)], 10, fa)]));
	}
}), [["__scopeId", "data-v-e7936a5a"]]), ha = { class: "ca-preview-social-wrapper" }, ga = /* @__PURE__ */ k({
	__name: "assembler-preview.social",
	props: { socialBlock: {} },
	setup(e) {
		let { getSocialName: t, SocialMediaPlatforms: n } = ke;
		return (r, i) => (P(), T("div", ha, [
			R(t)(e.socialBlock.content) === R(n).Youtube ? (P(), C(R(ma), {
				key: e.socialBlock.postId,
				"social-block": e.socialBlock
			}, null, 8, ["social-block"])) : w("", !0),
			R(t)(e.socialBlock.content) === R(n).Instagram ? (P(), C(R(na), {
				key: e.socialBlock.postId,
				"social-block": e.socialBlock
			}, null, 8, ["social-block"])) : w("", !0),
			R(t)(e.socialBlock.content) === R(n).Twitter ? (P(), C(R(ua), {
				key: e.socialBlock.postId,
				"social-block": e.socialBlock
			}, null, 8, ["social-block"])) : w("", !0),
			R(t)(e.socialBlock.content) === R(n).TikTok ? (P(), C(R(oa), {
				key: e.socialBlock.postId,
				"social-block": e.socialBlock
			}, null, 8, ["social-block"])) : w("", !0),
			R(t)(e.socialBlock.content) === R(n).Facebook ? (P(), C(R(Zi), {
				key: e.socialBlock.postId,
				"social-block": e.socialBlock
			}, null, 8, ["social-block"])) : w("", !0)
		]));
	}
}), _a = ["innerHTML"], va = {
	key: 3,
	class: "q-pb-md"
}, ya = /* @__PURE__ */ k({
	__name: "aissist-assembler-block",
	props: /* @__PURE__ */ A({
		block: {},
		isImageImportDisabled: {
			type: Boolean,
			default: !1
		}
	}, {
		previewDoc: {},
		previewDocModifiers: {}
	}),
	emits: ["update:previewDoc"],
	setup(e) {
		let t = z(e, "previewDoc");
		return (n, r) => e.block.type === "TEXT" || e.block.type === "PARTNER" ? (P(), T("div", {
			key: 0,
			class: "text-container q-pb-md",
			innerHTML: R(Q)(e.block.content)
		}, null, 8, _a)) : e.block.type === "IMAGE" ? (P(), C(zi, {
			key: 1,
			"preview-doc": t.value,
			"onUpdate:previewDoc": r[0] ||= (e) => t.value = e,
			class: "q-pb-sm",
			"image-block": e.block,
			"is-image-import-disabled": e.isImageImportDisabled
		}, null, 8, [
			"preview-doc",
			"image-block",
			"is-image-import-disabled"
		])) : e.block.type === "SOCIAL" ? (P(), C(ga, {
			key: e.block.postId,
			class: "q-pb-md",
			"social-block": e.block
		}, null, 8, ["social-block"])) : e.block.type === "QUOTE" ? (P(), T("blockquote", va, L(R(Q)(e.block.quote)), 1)) : e.block.type === "CTA_BUTTON" ? (P(), C(Ti, {
			key: 4,
			"cta-button-block": e.block
		}, null, 8, ["cta-button-block"])) : e.block.type === "NEWSLETTER" ? (P(), C(Wi, {
			key: 5,
			"newsletter-block": e.block
		}, null, 8, ["newsletter-block"])) : e.block.type === "GALLERY" ? (P(), C(Oi, {
			key: 6,
			"gallery-block": e.block
		}, null, 8, ["gallery-block"])) : e.block.type === "REUSABLE_TEXT" ? (P(), C(qi, {
			key: 7,
			"reusable-text-block": e.block
		}, null, 8, ["reusable-text-block"])) : w("", !0);
	}
}), ba = {
	"data-qa-aissist-ctf-block": "",
	class: "aissist-ctf-block-preview row items-center no-wrap q-gutter-x-sm"
}, xa = {
	key: 0,
	class: "aissist-ctf-block-preview__summary text-body2 text-grey-8"
}, Sa = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "aissist-ctf-block-preview",
	props: { block: {} },
	setup(e) {
		let n = e, r = S(() => Xr(n.block.type)), i = S(() => Zr(n.block));
		return (e, n) => (P(), T("div", ba, [O(R(t), {
			outline: "",
			color: "grey-7",
			label: r.value
		}, null, 8, ["label"]), i.value ? (P(), T("span", xa, L(i.value), 1)) : w("", !0)]));
	}
}), [["__scopeId", "data-v-76fabca5"]]), Ca = {
	"data-qa-aissist-preview-body": "",
	class: "ca-article-preview-body"
}, wa = ["innerHTML"], Ta = /* @__PURE__ */ k({
	__name: "aissist-preview.body",
	props: {
		aissistDoc: {},
		isImageImportDisabled: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = e, n = S(() => [...t.aissistDoc.blocks, ...t.aissistDoc.trailingBlocks ?? []]), r = F(t.aissistDoc.assemblerDoc ?? {});
		return B(() => t.aissistDoc.assemblerDoc, (e) => {
			r.value = e ?? {};
		}), (t, i) => (P(), T("div", Ca, [(P(!0), T(x, null, _e(n.value, (n, a) => (P(), T(x, { key: `aissist-block-${a}` }, [n.origin === "text" ? (P(), T("div", {
			key: 0,
			class: "text-container q-pb-md",
			innerHTML: R(Q)(n.content)
		}, null, 8, wa)) : n.origin === "assembler" ? (P(), C(ya, {
			key: 1,
			"preview-doc": r.value,
			"onUpdate:previewDoc": i[0] ||= (e) => r.value = e,
			block: n.block,
			"is-image-import-disabled": e.isImageImportDisabled
		}, null, 8, [
			"preview-doc",
			"block",
			"is-image-import-disabled"
		])) : n.origin === "ctf" ? I(t.$slots, "ctf-block", { block: n.block }, () => [O(Sa, { block: n.block }, null, 8, ["block"])], void 0, 2) : w("", !0)], 64))), 128))]));
	}
}), Ea = {
	key: 0,
	class: "assembler-doc-date text-muted text-body2"
}, Da = {
	key: 1,
	class: "assembler-doc-date text-muted text-body2"
}, Oa = /* @__PURE__ */ k({
	__name: "assembler-date.block",
	props: {
		previewDoc: {},
		displayDate: { default: "publishDate" },
		displayBothDates: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = e, { t: n } = U(), r = () => `${n("assemblerSorting.publishDate")}: ${Ce(t.previewDoc.publishDate)} | ${n("assemblerSorting.createDate")}: ${Ce(t.previewDoc.createDate)}`;
		return (n, i) => e.displayBothDates ? (P(), T("div", Ea, L(r()), 1)) : (P(), T("div", Da, L(R(Ce)(t.previewDoc[t.displayDate])), 1));
	}
}), ka = {
	"data-qa-assembler-preview-body": "",
	class: "ca-article-preview-body"
}, Aa = ["innerHTML"], ja = {
	key: 3,
	class: "q-pb-md"
}, Ma = /* @__PURE__ */ k({
	__name: "assembler-preview.body",
	props: /* @__PURE__ */ A({ isImageImportDisabled: {
		type: Boolean,
		default: !1
	} }, {
		previewDoc: {},
		previewDocModifiers: {}
	}),
	emits: ["update:previewDoc"],
	setup(e) {
		let t = z(e, "previewDoc");
		return (n, r) => (P(), T("div", ka, [(P(!0), T(x, null, _e(t.value?.content, (n, i) => (P(), T(x, { key: `content-item-${i}` }, [n.type === "TEXT" || n.type === "PARTNER" ? (P(), T("div", {
			key: 0,
			class: "text-container q-pb-md",
			innerHTML: R(Q)(n.content)
		}, null, 8, Aa)) : n.type === "IMAGE" ? (P(), C(zi, {
			key: 1,
			"preview-doc": t.value,
			"onUpdate:previewDoc": r[0] ||= (e) => t.value = e,
			class: "q-pb-sm",
			"image-block": n,
			"is-image-import-disabled": e.isImageImportDisabled
		}, null, 8, [
			"preview-doc",
			"image-block",
			"is-image-import-disabled"
		])) : n.type === "SOCIAL" ? (P(), C(ga, {
			key: n.postId,
			class: "q-pb-md",
			"social-block": n
		}, null, 8, ["social-block"])) : n.type === "QUOTE" ? (P(), T("blockquote", ja, L(R(Q)(n.quote)), 1)) : n.type === "CTA_BUTTON" ? (P(), C(Ti, {
			key: 4,
			"cta-button-block": n
		}, null, 8, ["cta-button-block"])) : n.type === "NEWSLETTER" ? (P(), C(Wi, {
			key: 5,
			"newsletter-block": n
		}, null, 8, ["newsletter-block"])) : n.type === "GALLERY" ? (P(), C(Oi, {
			key: 6,
			"gallery-block": n
		}, null, 8, ["gallery-block"])) : n.type === "REUSABLE_TEXT" ? (P(), C(qi, {
			key: 7,
			"reusable-text-block": n
		}, null, 8, ["reusable-text-block"])) : w("", !0)], 64))), 128))]));
	}
}), Na = { "data-qa-assembler-preview-body-container": "" }, Pa = { class: "text-black bg-white q-layout-padding q-py-sm" }, Fa = {
	key: 0,
	class: "q-pb-sm q-pt-sm row full-width justify-center"
}, Ia = { class: "ca-article-preview-lead-text text-primary text-bold q-pb-md" }, La = /* @__PURE__ */ k({
	__name: "assembler-preview-body.container",
	props: /* @__PURE__ */ A({
		showDate: {
			type: Boolean,
			default: void 0
		},
		displayBothDates: {
			type: Boolean,
			default: void 0
		},
		isImageImportDisabled: {
			type: Boolean,
			default: !1
		}
	}, {
		previewDoc: {},
		previewDocModifiers: {}
	}),
	emits: ["update:previewDoc"],
	setup(e) {
		let t = z(e, "previewDoc");
		return (n, r) => (P(), T("div", Na, [E("div", Pa, [
			I(n.$slots, "preview-main-media", {}, () => [t.value?.mainImage ? (P(), C(zi, {
				key: 0,
				"preview-doc": t.value,
				"onUpdate:previewDoc": r[0] ||= (e) => t.value = e,
				"image-block": t.value.mainImage,
				"is-image-import-disabled": e.isImageImportDisabled
			}, null, 8, [
				"preview-doc",
				"image-block",
				"is-image-import-disabled"
			])) : w("", !0)]),
			t.value && e.showDate ? (P(), T("div", Fa, [O(Oa, {
				"preview-doc": t.value,
				"display-both-dates": e.displayBothDates
			}, null, 8, ["preview-doc", "display-both-dates"])])) : w("", !0),
			I(n.$slots, "preview-body", {}, () => [E("div", Ia, [E("p", null, L(R(Q)(t.value?.leadText)), 1)]), t.value ? (P(), C(Ma, {
				key: 0,
				"preview-doc": t.value,
				"onUpdate:previewDoc": r[1] ||= (e) => t.value = e,
				"is-image-import-disabled": e.isImageImportDisabled
			}, null, 8, ["preview-doc", "is-image-import-disabled"])) : w("", !0)])
		])]));
	}
}), Ra = {
	key: 1,
	class: "q-mb-md"
}, za = { class: "row no-wrap" }, Ba = { class: "col-6 q-pr-lg" }, Va = { class: "text-subtitle1 text-center" }, Ha = { class: "ca-article-preview-lead-text text-primary text-bold" }, Ua = { class: "col-6 q-pl-lg" }, Wa = { class: "text-subtitle1 text-center" }, Ga = { class: "ca-article-preview-lead-text text-primary text-bold" }, Ka = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "aissist-transform-preview.container",
	props: {
		originalDoc: {},
		transformedDoc: {},
		mainMedia: {}
	},
	setup(e) {
		let t = e, { t: n } = U(), r = S(() => Gr(t.transformedDoc));
		return (t, i) => (P(), C(La, {
			id: "aissist-preview-body-container",
			"preview-doc": r.value,
			"data-qa-aissist-import-preview-container": "",
			"is-image-import-disabled": "",
			"main-media": e.mainMedia
		}, ce({
			"preview-body": V(() => [E("div", za, [E("div", Ba, [
				E("div", Va, L(R(n)("assemblerAissistTransform.original")), 1),
				O(R(g), { class: "q-my-sm" }),
				E("div", Ha, [E("p", null, L(e.originalDoc.leadText), 1)]),
				O(Ta, {
					"aissist-doc": e.originalDoc,
					"is-image-import-disabled": ""
				}, ce({ _: 2 }, [t.$slots["ctf-block"] ? {
					name: "ctf-block",
					fn: V((e) => [I(t.$slots, "ctf-block", pe(ue(e)), void 0, !0)]),
					key: "0"
				} : void 0]), 1032, ["aissist-doc"])
			]), E("div", Ua, [
				E("div", Wa, L(R(n)("assemblerAissistTransform.aissistOutput")), 1),
				O(R(g), { class: "q-my-sm" }),
				E("div", Ga, [E("p", null, L(e.transformedDoc.leadText), 1)]),
				O(Ta, {
					"aissist-doc": e.transformedDoc,
					"is-image-import-disabled": ""
				}, ce({ _: 2 }, [t.$slots["ctf-block"] ? {
					name: "ctf-block",
					fn: V((e) => [I(t.$slots, "ctf-block", pe(ue(e)), void 0, !0)]),
					key: "0"
				} : void 0]), 1032, ["aissist-doc"])
			])])]),
			_: 2
		}, [t.$slots["main-media"] ? {
			name: "preview-main-media",
			fn: V(() => [I(t.$slots, "main-media", {}, void 0, !0)]),
			key: "0"
		} : e.mainMedia ? {
			name: "preview-main-media",
			fn: V(() => [e.mainMedia?.type === "image" && e.mainMedia.media ? (P(), C(zi, {
				key: 0,
				"preview-doc": r.value,
				"image-block": e.mainMedia.media,
				"is-image-import-disabled": ""
			}, null, 8, ["preview-doc", "image-block"])) : e.mainMedia?.type === "video" && e.mainMedia.media ? (P(), T("div", Ra, [I(t.$slots, "main-media-video", { video: e.mainMedia.media }, void 0, !0)])) : w("", !0)]),
			key: "1"
		} : void 0]), 1032, ["preview-doc", "main-media"]));
	}
}), [["__scopeId", "data-v-b2218ad4"]]), qa = Symbol("assemblerListLocking");
function Ja(e) {
	let t = S(() => e?.locks);
	function n(t, n) {
		let r = t._id;
		if (!r || !e) return;
		let i = t.linkedContentsRef?.map((e) => e.contentUuid) ?? [], a = (n ?? t.allowedBrands ?? []).map((e) => si(r, e)), o = [...i, ...a];
		o.length && e.addWatchedArticleUuids(o);
	}
	function r(e) {
		return R(t)?.[e];
	}
	function i(e) {
		return ci(R(t), e);
	}
	function a(e, n, r, i) {
		return li(R(t), e, n, i, r);
	}
	return {
		locks: t,
		registerLockWatchTargets: n,
		getLockState: r,
		isLocked: i,
		formatLockLabel: a
	};
}
function Ya(e = {}) {
	if (!(e.enabled ?? !0)) return;
	let t = F([]);
	function n(e) {
		let n = e.filter((e) => !t.value.includes(e));
		n.length && (t.value = [...t.value, ...n]);
	}
	let r = Ue("content", t), i = Object.assign(r, { addWatchedArticleUuids: n });
	return ge(qa, i), N(async () => {
		await r.init();
	}), me(() => {
		r.teardown(), r.clearInitializedResources?.();
	}), Ja(i);
}
function Xa() {
	return Ja(de(qa, void 0));
}
//#endregion
//#region src/components/aissist/transform/aissist-transform.dialog.vue?vue&type=script&setup=true&lang.ts
var Za = { class: "row q-gutter-md" }, Qa = { class: "col" }, $a = {
	key: 0,
	class: "col",
	"data-qa-aissist-brand-select": ""
}, eo = { class: "row q-gutter-md" }, to = { class: "col" }, no = {
	class: "row items-center q-gutter-sm",
	"data-qa-aissist-format-row": ""
}, ro = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "aissist-transform.dialog",
	props: /* @__PURE__ */ A({
		transformDoc: {},
		availableBrands: { default: () => [] },
		requireBrand: {
			type: Boolean,
			default: !1
		},
		mainMedia: { default: void 0 },
		promptTarget: { default: Ar.ARTICLE },
		importButtonLabel: { default: void 0 }
	}, {
		modelValue: { type: Boolean },
		modelModifiers: {}
	}),
	emits: /* @__PURE__ */ A(["closeAissistDialog"], ["update:modelValue"]),
	setup(e, { emit: t }) {
		let r = se(), { t: i } = U(), a = De(), s = t, { required: l } = Se, u = e, d = de(Ur), f = z(e, "modelValue"), p = F(void 0), m = F(void 0), h = F(1), ee = F(!1), _ = F(), y = F(""), b = F(!1), x = gt(), { getPromptTemplate: le } = x, D = F(le()), { registerLockWatchTargets: k, isLocked: A, getLockState: j } = Xa(), M = F({
			prompt: D.value,
			format: Or.HTML,
			brand: void 0,
			aissistActionType: kr.REPHRASE,
			additionalInstructions: ""
		}), me = S(() => Pr(M.value.format)), he = (e) => oe.formatDate(e, "DD.MM.YY HH:mm") ?? "---", ge = S(() => Ke.filter((e) => !u.availableBrands?.includes(e))), _e = S(() => {
			let e = [];
			return e.push(jr("target", u.promptTarget)), M.value.brand && e.push(jr("brand", M.value.brand.toLowerCase())), M.value.aissistActionType && e.push(jr("action", M.value.aissistActionType.toLowerCase())), e;
		}), B = S(() => [() => !!M.value.prompt.system_prompt?.trim() || !!M.value.additionalInstructions?.trim() || i("assemblerAissistTransform.atLeastOnePromptRequired")]), ve = () => {
			if (!M.value.prompt?.name) {
				M.value.prompt?.system_prompt ? M.value.prompt = {
					...D.value,
					system_prompt: M.value.prompt.system_prompt
				} : M.value.prompt = { ...D.value };
				return;
			}
			let e = M.value.prompt?.name, t = x.aissistPrompts.find((t) => t.name === e);
			if (!t) {
				let e = M.value.prompt.system_prompt;
				M.value.prompt = {
					...D.value,
					system_prompt: e
				}, M.value.brand && x.arePromptsInitialized && a.showNotification(new H(i("assemblerAissistTransform.error.promptNotFound"), "negative"));
				return;
			}
			M.value.prompt = { ...t };
		}, ye = async () => {
			b.value || (h.value = 1, _.value = void 0, y.value = "");
		}, xe = () => {
			b.value || (ye(), M.value.prompt = D.value, M.value.additionalInstructions = "", ee.value = !1, f.value = !1, s("closeAissistDialog"));
		}, Ce = async (e) => {
			for (let t = 1; t <= 45; t++) {
				try {
					let t = await Xe(e);
					if (t.status === "completed" || t.status === "failed") return t;
				} catch (e) {
					console.error("Failed to fetch AISSIST transformation status, continuing: ", e);
				}
				t < 45 && await new Promise((e) => setTimeout(e, 2e3));
			}
			a.showNotification(new H(i("assemblerAissistTransform.error.transformTimeout"), "negative"));
		}, we = async (e, t, n, o) => {
			try {
				b.value = !0, r.loading.show({ message: n });
				let s = await Ye({
					prompt: {
						...M.value.prompt,
						system_prompt: e
					},
					data: Br(t, M.value.format),
					additionalInstructions: o
				});
				if (s.status !== "queued" || !s.job_id) {
					a.showNotification(new H(i("assemblerAissistTransform.error.transformInitError"), "negative"));
					return;
				}
				let c = await Ce(s.job_id);
				if (!c) return;
				if (c.status === "completed" && c.result) return await Vr(t, c.result, M.value.format);
				if (c.status === "failed") {
					let e = c.error ? `${i("assemblerAissistTransform.error.transformErrorGeneral")}: ${c.error}` : i("assemblerAissistTransform.error.transformErrorGeneral");
					a.showNotification(new H(e, "negative"));
				}
				return;
			} catch (e) {
				console.error("Failed to initialize the AISSIST transformation: ", e);
				return;
			} finally {
				b.value = !1, r.loading.hide();
			}
		}, Te = async () => {
			if (!await p.value?.validate(!0)) return;
			let e = M.value.additionalInstructions?.trim() || void 0, t = await we(Fr(me.value, M.value.prompt.system_prompt), u.transformDoc, i("assemblerAissistTransform.loadingMessage"), e);
			t && (_.value = t, y.value = "", m.value?.next());
		}, Ee = async () => {
			let e = y.value?.trim(), t = _.value;
			if (!e || !t) return;
			let n = await we(Ir(me.value, e), t, i("assemblerAissistTransform.refineLoadingMessage"));
			if (!n) return;
			_.value = n, y.value = "", await fe();
			let r = m.value?.$el;
			r instanceof HTMLElement && (r.scrollTop = 0);
		}, Oe = async () => {
			!_.value || !d || u.requireBrand && !M.value.brand || d(_.value, M.value.brand);
		}, ke = S(() => {
			let e = {
				label: i("assemblerAissistTransform.actionType.rephrase"),
				value: kr.REPHRASE
			};
			return u.promptTarget === Ar.TRANSCRIPT ? [e] : [
				e,
				{
					label: i("assemblerAissistTransform.actionType.translate"),
					value: kr.TRANSLATE
				},
				{
					label: i("assemblerAissistTransform.actionType.seo"),
					value: kr.SEO
				},
				{
					label: i("assemblerAissistTransform.actionType.optimize"),
					value: kr.OPTIMIZE
				}
			];
		}), Ae = S(() => {
			if (!(!u.requireBrand || !M.value.brand || !u.transformDoc.id)) return si(u.transformDoc.id, M.value.brand);
		}), je = S(() => b.value ? !0 : u.requireBrand ? Ae.value ? A(Ae.value) : !0 : !1), Me = S(() => je.value || !y.value?.trim());
		function Ne(e) {
			let t = M.value.brand, n = Ae.value;
			if (u.requireBrand && t && n && A(n)) {
				let e = j(n);
				return `${i("assembler.lockedBy")} ${e?.ownerName} ${e?.createdAt && `(${he(e.createdAt)})`}`;
			}
			return e === "import" && u.importButtonLabel ? u.importButtonLabel : i(e === "transform" ? "assemblerAissistTransform.transform" : "assembler.dropdownImport");
		}
		return N(() => {
			_t(), u.requireBrand && u.transformDoc.assemblerDoc?._id && k(u.transformDoc.assemblerDoc, u.availableBrands);
		}), (t, r) => (P(), C(R(o), {
			"data-qa-aissist-import-dialog": "",
			"model-value": f.value,
			container: "",
			persistent: b.value,
			"no-esc-dismiss": b.value,
			onHide: xe
		}, {
			default: V(() => [O(R(ie), {
				ref_key: "stepper",
				ref: m,
				modelValue: h.value,
				"onUpdate:modelValue": r[10] ||= (e) => h.value = e,
				"data-qa-aissist-import-stepper": "",
				"keep-alive": !1,
				color: "primary",
				animated: "",
				class: "aissist-import-stepper"
			}, {
				navigation: V(() => [O(R(ae), {
					"data-qa-aissist-import-nav": "",
					class: "row items-center no-wrap q-gutter-x-md"
				}, {
					default: V(() => [
						O(R(n), {
							"data-qa-aissist-cancel-button": "",
							color: "secondary",
							label: R(i)("common.cancel"),
							icon: "cancel",
							disable: b.value,
							onClick: xe
						}, null, 8, ["label", "disable"]),
						h.value === 2 ? (P(), C(R(n), {
							key: 0,
							"data-qa-aissist-discard-button": "",
							outline: "",
							color: "primary",
							icon: "trash",
							label: R(i)("assemblerAissistTransform.startAgain"),
							disable: b.value,
							onClick: ye
						}, null, 8, ["label", "disable"])) : w("", !0),
						O(R(re)),
						h.value === 1 ? (P(), C(R(n), {
							key: 1,
							"data-qa-aissist-transform-button": "",
							icon: "send",
							label: Ne("transform"),
							color: "primary",
							disable: je.value,
							onClick: Te
						}, null, 8, ["label", "disable"])) : w("", !0),
						h.value === 2 ? (P(), C(R(n), {
							key: 2,
							"data-qa-aissist-refine-button": "",
							icon: "auto_fix_high",
							label: R(i)("assemblerAissistTransform.refine"),
							color: "primary",
							outline: "",
							disable: Me.value,
							onClick: Ee
						}, null, 8, ["label", "disable"])) : w("", !0),
						h.value === 2 ? (P(), C(R(n), {
							key: 3,
							"data-qa-aissist-import-button": "",
							icon: "send",
							label: Ne("import"),
							color: "primary",
							disable: je.value,
							onClick: Oe
						}, null, 8, ["label", "disable"])) : w("", !0)
					]),
					_: 1
				})]),
				default: V(() => [
					O(R(v), {
						name: 1,
						title: R(i)("assemblerAissistTransform.transform"),
						icon: "cog",
						done: h.value > 1,
						draggable: !1
					}, {
						default: V(() => [O(R(c), {
							ref_key: "form",
							ref: p,
							"data-qa-aissist-import-form": "",
							greedy: ""
						}, {
							default: V(() => [
								E("div", Za, [E("div", Qa, [O(R(ne), {
									modelValue: M.value.aissistActionType,
									"onUpdate:modelValue": r[0] ||= (e) => M.value.aissistActionType = e,
									class: "q-field--with-bottom",
									"data-qa-aissist-action-type-select": "",
									options: ke.value,
									disable: !R(x).arePromptsInitialized,
									loading: R(x).isInitializingPrompts,
									"emit-value": "",
									"map-options": "",
									label: R(i)("assemblerAissistTransform.actionType.label"),
									dense: "",
									outlined: "",
									"dropdown-icon": "expand_more"
								}, null, 8, [
									"modelValue",
									"options",
									"disable",
									"loading",
									"label"
								])]), e.requireBrand ? (P(), T("div", $a, [O(R(be), {
									modelValue: M.value.brand,
									"onUpdate:modelValue": r[1] ||= (e) => M.value.brand = e,
									label: R(i)("assemblerAissistTransform.brand"),
									class: "required",
									required: "",
									rules: [R(l)],
									"allow-blank-option": !1,
									"only-brands": "",
									"disabled-brands": ge.value
								}, null, 8, [
									"modelValue",
									"label",
									"rules",
									"disabled-brands"
								])])) : w("", !0)]),
								O(xi, {
									"show-additional-settings": ee.value,
									"onUpdate:showAdditionalSettings": r[2] ||= (e) => ee.value = e,
									prompt: M.value.prompt,
									"onUpdate:prompt": r[3] ||= (e) => M.value.prompt = e,
									class: "q-mb-md",
									onResetPrompt: ve
								}, null, 8, ["show-additional-settings", "prompt"]),
								E("div", eo, [E("div", to, [O(gi, {
									modelValue: M.value.prompt,
									"onUpdate:modelValue": r[4] ||= (e) => M.value.prompt = e,
									disable: !R(x).arePromptsInitialized,
									"filter-tags": _e.value
								}, null, 8, [
									"modelValue",
									"disable",
									"filter-tags"
								])])]),
								O(_i, {
									modelValue: M.value.prompt.system_prompt,
									"onUpdate:modelValue": r[5] ||= (e) => M.value.prompt.system_prompt = e,
									"data-qa-aissist-input-prompt": "",
									label: R(i)("assemblerAissistTransform.prompt"),
									rules: B.value,
									class: "required q-mt-sm",
									"stack-label": "",
									placeholder: R(i)("assemblerAissistTransform.promptPlaceholder"),
									rows: 1,
									disable: R(x).isInitializingPrompts
								}, null, 8, [
									"modelValue",
									"label",
									"rules",
									"placeholder",
									"disable"
								]),
								O(_i, {
									modelValue: M.value.additionalInstructions,
									"onUpdate:modelValue": r[6] ||= (e) => M.value.additionalInstructions = e,
									"data-qa-aissist-input-additional-instructions": "",
									label: R(i)("assemblerAissistTransform.additionalInstructions"),
									rules: B.value,
									class: "required q-mt-sm",
									"stack-label": "",
									"hide-expand-toggle": "",
									placeholder: R(i)("assemblerAissistTransform.additionalInstructionsPlaceholder"),
									clearable: ""
								}, null, 8, [
									"modelValue",
									"label",
									"rules",
									"placeholder"
								]),
								E("div", no, [
									E("label", null, L(R(i)("assemblerAissistTransform.processFormat")) + ":", 1),
									O(R(te), {
										modelValue: M.value.format,
										"onUpdate:modelValue": r[7] ||= (e) => M.value.format = e,
										"data-qa-aissist-format-html": "",
										val: R(Or).HTML,
										label: R(i)("assemblerAissistTransform.html")
									}, null, 8, [
										"modelValue",
										"val",
										"label"
									]),
									O(R(te), {
										modelValue: M.value.format,
										"onUpdate:modelValue": r[8] ||= (e) => M.value.format = e,
										"data-qa-aissist-format-markdown": "",
										val: R(Or).MARKDOWN,
										label: R(i)("assemblerAissistTransform.markdown")
									}, null, 8, [
										"modelValue",
										"val",
										"label"
									])
								])
							]),
							_: 1
						}, 512)]),
						_: 1
					}, 8, ["title", "done"]),
					O(R(v), {
						name: 2,
						title: R(i)("assemblerAissistTransform.checkResult"),
						icon: "eye",
						done: h.value > 2,
						draggable: !1
					}, {
						default: V(() => [
							_.value ? (P(), C(Ka, {
								key: 0,
								"original-doc": e.transformDoc,
								"transformed-doc": _.value,
								"main-media": e.mainMedia
							}, ce({
								"main-media-video": V((e) => [I(t.$slots, "main-media-video", pe(ue(e)), void 0, !0)]),
								_: 2
							}, [t.$slots["main-media"] ? {
								name: "main-media",
								fn: V(() => [I(t.$slots, "main-media", {}, void 0, !0)]),
								key: "0"
							} : void 0, t.$slots["ctf-block"] ? {
								name: "ctf-block",
								fn: V((e) => [I(t.$slots, "ctf-block", pe(ue(e)), void 0, !0)]),
								key: "1"
							} : void 0]), 1032, [
								"original-doc",
								"transformed-doc",
								"main-media"
							])) : w("", !0),
							O(R(g)),
							_.value ? (P(), C(_i, {
								key: 1,
								modelValue: y.value,
								"onUpdate:modelValue": r[9] ||= (e) => y.value = e,
								"data-qa-aissist-refinement-instructions": "",
								class: "q-mt-md",
								label: R(i)("assemblerAissistTransform.refinementInstructions"),
								"stack-label": "",
								"hide-expand-toggle": "",
								clearable: "",
								disable: b.value,
								placeholder: R(i)("assemblerAissistTransform.refinementInstructionsPlaceholder"),
								rows: 2
							}, null, 8, [
								"modelValue",
								"label",
								"disable",
								"placeholder"
							])) : w("", !0)
						]),
						_: 3
					}, 8, ["title", "done"]),
					O(R(v), {
						name: 3,
						title: R(i)("assembler.dropdownImport"),
						icon: "check",
						done: h.value > 3,
						draggable: !1
					}, null, 8, ["title", "done"])
				]),
				_: 3
			}, 8, ["modelValue"])]),
			_: 3
		}, 8, [
			"model-value",
			"persistent",
			"no-esc-dismiss"
		]));
	}
}), [["__scopeId", "data-v-fb39f929"]]), io = { class: "row q-col-gutter-md q-mb-md feed-stats-date-selectors" }, ao = 2026, oo = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "feed-stats-date.selectors",
	props: /* @__PURE__ */ A({
		disable: {
			type: Boolean,
			default: !1
		},
		isFullWidth: {
			type: Boolean,
			default: !1
		}
	}, {
		year: { required: !0 },
		yearModifiers: {},
		month: { required: !0 },
		monthModifiers: {}
	}),
	emits: ["update:year", "update:month"],
	setup(e, { expose: t }) {
		let n = z(e, "year"), r = z(e, "month"), { t: i, locale: a } = U(), o = S(() => {
			let e = (/* @__PURE__ */ new Date()).getUTCFullYear(), t = [];
			for (let n = ao; n <= e; n += 1) t.push({
				label: String(n),
				value: n
			});
			return t;
		}), s = S(() => Array.from({ length: 12 }, (e, t) => {
			let n = t + 1;
			return {
				label: new Intl.DateTimeFormat(a.value, {
					month: "long",
					timeZone: "UTC"
				}).format(new Date(Date.UTC(2e3, t, 1))),
				value: n
			};
		})), c = () => {
			let e = (/* @__PURE__ */ new Date()).getUTCFullYear();
			n.value < ao && (n.value = ao), n.value > e && (n.value = e);
		};
		return he(() => {
			c();
		}), t({ clampSelectedYear: c }), (t, a) => (P(), T("div", io, [E("div", { class: j(e.isFullWidth ? "col-6" : "col-auto") }, [O(R(ne), {
			modelValue: r.value,
			"onUpdate:modelValue": a[0] ||= (e) => r.value = e,
			class: j({
				"full-width": e.isFullWidth,
				"selector-style": !e.isFullWidth
			}),
			options: s.value,
			label: R(i)("feedStatsTab.monthLabel"),
			dense: "",
			"emit-value": "",
			flat: "",
			"map-options": "",
			outlined: "",
			"dropdown-icon": "expand_more",
			disable: e.disable
		}, null, 8, [
			"modelValue",
			"class",
			"options",
			"label",
			"disable"
		])], 2), E("div", { class: j(e.isFullWidth ? "col-6" : "col-auto") }, [O(R(ne), {
			modelValue: n.value,
			"onUpdate:modelValue": a[1] ||= (e) => n.value = e,
			class: j({
				"full-width": e.isFullWidth,
				"selector-style": !e.isFullWidth
			}),
			options: o.value,
			label: R(i)("feedStatsTab.yearLabel"),
			dense: "",
			"emit-value": "",
			flat: "",
			"map-options": "",
			outlined: "",
			"dropdown-icon": "expand_more",
			disable: e.disable
		}, null, 8, [
			"modelValue",
			"class",
			"options",
			"label",
			"disable"
		])], 2)]));
	}
}), [["__scopeId", "data-v-145ff402"]]);
//#endregion
//#region src/utils/feed-stats.bar-width.ts
function so(e, t) {
	return t <= 0 || e <= 0 ? "0%" : `${Math.sqrt(Math.min(e, t)) / Math.sqrt(t) * 100}%`;
}
//#endregion
//#region src/components/feed-stats/feed-stats.bar.vue?vue&type=script&setup=true&lang.ts
var co = { class: "feed-stats-bar-line" }, lo = { class: "feed-stats-bar-label" }, uo = { class: "feed-stats-bar-count" }, fo = { class: "feed-stats-bar-track" }, po = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "feed-stats.bar",
	props: {
		maxCount: {},
		count: {},
		color: {},
		label: {}
	},
	setup(e) {
		let t = e, n = S(() => so(t.count, t.maxCount));
		return (t, r) => (P(), T("div", co, [
			E("span", lo, L(e.label), 1),
			E("span", uo, L(e.count), 1),
			E("div", fo, [E("div", {
				class: "feed-stats-bar-fill",
				style: M({
					width: n.value,
					backgroundColor: e.color
				})
			}, null, 4)])
		]));
	}
}), [["__scopeId", "data-v-6128e1ee"]]), mo = { class: "feed-stats-imported-published-bars" }, ho = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "feed-stats-imported-published.bars",
	props: {
		importedColor: {},
		publishedColor: {},
		importedCount: {},
		publishedCount: {},
		maxCount: {}
	},
	setup(e) {
		let { t } = U();
		return (n, r) => (P(), T("div", mo, [O(po, {
			"max-count": e.maxCount,
			count: e.importedCount,
			color: e.importedColor,
			label: R(t)("feedStatsTab.imported")
		}, null, 8, [
			"max-count",
			"count",
			"color",
			"label"
		]), O(po, {
			"max-count": e.maxCount,
			count: e.publishedCount,
			color: e.publishedColor,
			label: R(t)("feedStatsTab.published")
		}, null, 8, [
			"max-count",
			"count",
			"color",
			"label"
		])]));
	}
}), [["__scopeId", "data-v-f056450e"]]), go = {
	routes: [],
	messages: We
};
//#endregion
export { Ar as AISSISTPromptTargetEnum, kr as AISSISTPromptsActionTypeEnum, Nr as AISSISTPromptsTagPrefixesEnum, Or as AISSISTTransformFormatEnum, Ur as AISSIST_IMPORT_TRANSFORMED_DOC_KEY, Mr as AISSIST_PROMPT_TYPE_DEFAULT_TAG, qa as ASSEMBLER_CONTENT_LOCKING_KEY, ro as AissistTransformDialog, Oa as AssemblerDate, it as AssemblerFeedModelName, at as AssemblerFeedService, ct as AssemblerFeedStatsModelName, lt as AssemblerFeedStatsService, $e as AssemblerModelName, La as AssemblerPreviewBodyContainer, et as AssemblerService, oo as FeedStatsDateSelectors, ho as FeedStatsImportedPublishedBars, Ye as aissistAsyncTransformAssemblerInit, Gr as aissistDocumentToAssemblerContent, Jr as aissistDocumentToCtfContents, Ze as aissistPromptTemplatesByTags, go as assemblerComponentsModule, ui as assemblerPreviewTransformQuotes, Wr as assemblerToAissistDocument, jr as buildAissistPromptFilterTag, Ir as buildAissistRefineSystemPrompt, Fr as buildAissistTransformSystemPrompt, Vr as buildDocFromAissistOutput, ti as buildImportHistoryEntry, qr as ctfContentsToAissistDocument, ei as findImportedCtfAssetUuid, Br as formatArticleForAissist, li as formatAssemblerLockLabel, Xe as getAissistAsyncTransformAssemblerResult, Pr as getAissistDialogPromptStart, Qe as getAissistProviders, Hr as getAssemblerDocAvailableBrands, st as getAssemblerFeed, mt as getAssemblerFeedStatsCompleteReport, pt as getAssemblerFeedStatsList, Zr as getBlockPreviewLabel, Xr as getBlockPreviewName, si as getBrandedArticleUuid, Rr as html2markdown, _t as initializeAissistPrompts, yt as initializeAissistProviders, ci as isAssemblerArticleLocked, di as loadSocialWidgetScript, zr as markdown2html, Lr as normalizeAissistTransformOutput, ni as replaceImportHistoryEntry, oi as resolveCtfImageUrl, $r as resolveImageBlockAssetId, ri as resolveImageImportRole, Q as transformQuotesToTop, Kr as transformedPartnerTexts, rt as updateAssemblerImportHistory, gt as useAissistPrompts, vt as useAissistProviders, Xa as useAssemblerLocking, Ya as useProvideAssemblerContentLocking };

//# sourceMappingURL=index.es.js.map